"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1747],{

/***/ 12547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K_": function() { return /* binding */ LinkAd; },
  "ZP": function() { return /* binding */ AdSelection; }
});

// UNUSED EXPORTS: MediaAd, ProviderAd

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/index.js + 3 modules
var utils = __webpack_require__(12311);
// EXTERNAL MODULE: ./src/utils/news.js
var utils_news = __webpack_require__(98993);
// EXTERNAL MODULE: ./src/features/base-ui/index.js + 31 modules
var base_ui = __webpack_require__(82843);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./src/features/base-ui/Image.js
var Image = __webpack_require__(94477);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./src/hooks/useBreakpoints.js
var useBreakpoints = __webpack_require__(22807);
;// CONCATENATED MODULE: ./src/features/ads/StickyAd.jsx







function StickyAd(param) {
    var imageSrc = param.imageSrc, href = param.href, title = param.title, _orientation = param.orientation, orientation = _orientation === void 0 ? "horizontal" : _orientation, style = param.style, _width = param.width, width = _width === void 0 ? 170 : _width, _height = param.height, height = _height === void 0 ? 230 : _height;
    var ref = (0,react.useState)(true), visible = ref[0], setVisible = ref[1];
    var breakpoint = (0,useBreakpoints/* default */.Z)({
        xs: false
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "dasdsadasds",
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:fixed;display:", visible === true ? "block" : "none", ";bottom:50px;right:10px;border:1px solid #ff9aa6;height:", orientation === "vertical" ? height + "px" : "100px", ";width:", orientation === "vertical" ? width + "px" : "300px", ";", orientation !== "vertical" && breakpoint.xs && "width: 95%", ";border-radius:10px;z-index:99;border-bottom-right-radius:0;.body{flex-direction:", orientation === "vertical" ? "column" : "row", ";.adImage{width:", orientation === "vertical" ? "100%" : "100px", ";padding:", orientation !== "vertical" ? "0.25rem" : "0", ";display:flex;justify-content:center;align-items:center;img{border-bottom-right-radius:", orientation !== "vertical" ? "0" : false, ";}}.adClick{margin:0.25rem auto;padding:0.125rem 0.5rem;background-color:#ef233c;border-radius:0.25rem;font-size:0.8rem;color:#fff;min-width:70px;}}box-shadow:0 3.1px 5.4px rgba(0,0,0,0.057),0 10.3px 18.1px rgba(0,0,0,0.083),0 46px 81px rgba(0,0,0,0.14);"),
        style: style,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                css: buttonStyles,
                onClick: function() {
                    setVisible(false);
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        className: "text",
                        children: "بستن"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* IoCloseSharp */.Lp2, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                href: href,
                style: {
                    display: "block",
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "relative w-full h-full flex body bg-white rounded-lg",
                    children: [
                        imageSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "order-1 adImage",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                                noStyle: true,
                                src: imageSrc,
                                alt: "picture",
                                width: orientation === "vertical" ? width : 100,
                                height: orientation === "vertical" ? height / 2 : 100,
                                objectFit: "cover",
                                className: "rounded-lg"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "h-full bg-white flex order-2 adText",
                            css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-bottom-left-radius:10px;border-top-left-radius:", orientation === "vertical" ? 0 : "10px", ";opacity:95%;z-index:99;padding:2px 5px;overflow:hidden;width:", orientation === "vertical" || !imageSrc ? "100%" : "70%", ";gap:", orientation === "vertical" || !imageSrc ? "1rem" : "0.5rem", ";flex-direction:column;align-items:center;justify-content:center;"),
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    style: {
                                        fontSize: "0.85rem",
                                        lineHeight: "1.15rem",
                                        textAlign: "right",
                                        overflow: "hidden",
                                        display: "-webkit-box",
                                        WebkitBoxOrient: "vertical",
                                        WebkitLineClamp: 3
                                    },
                                    children: title
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "adClick",
                                    children: "کلیک کنید"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var ads_StickyAd = (StickyAd);
var buttonStyles = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("position:absolute;display:flex;top:-25px;border-radius:4px;left:0;font-size:1.5rem;z-index:999;color:#ef233c;.text{font-size:0.8rem;}background-color:#ffffffe0;padding-right:0.25rem;");

;// CONCATENATED MODULE: ./src/features/ads/StickyAdBottom.js







function StickyAdBottom(param) {
    var ad = param.ad, imgSrc = param.imgSrc, href = param.href, title = param.title, _displayStyle = param.displayStyle, displayStyle = _displayStyle === void 0 ? "media_text" : _displayStyle, _position = param.position, position = _position === void 0 ? "bottom" : _position, style = param.style;
    var ref, ref1;
    var ref2 = (0,react.useState)(true), visible = ref2[0], setVisible = ref2[1];
    var mainStyle = {
        width: "100vw",
        backgroundColor: "#ffffff",
        height: "56px",
        position: "fixed",
        zIndex: "99",
        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
        display: visible === true ? "flex" : "none",
        alignItems: "center"
    };
    if (position === "bottom") mainStyle.bottom = 0;
    else if (position === "top") {
        mainStyle.top = 0;
        mainStyle.position = "sticky";
    }
    var linkStyle = "display: block; margin: 0 auto; padding: 0 0.5rem; a { display: flex; justify-content: center; align-items: center; gap: 0.25rem;}";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        style: (0,_object_spread/* default */.Z)({}, mainStyle, style),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Link */.rU, {
            href: href !== null && href !== void 0 ? href : (0,utils/* generateUrl */.nu)(ad, "news"),
            style: linkStyle,
            children: [
                (imgSrc || (ad === null || ad === void 0 ? void 0 : (ref = ad.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.hash)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    style: {
                        minWidth: "4rem"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Image */.Ee, {
                        src: imgSrc !== null && imgSrc !== void 0 ? imgSrc : (0,utils_news/* thumbnailSrc */.xX)(ad.thumbnail),
                        alt: "picture",
                        width: displayStyle === "media_text" ? 90 : 350,
                        height: 56
                    })
                }),
                displayStyle === "media_text" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            style: {
                                fontSize: "0.9rem",
                                textAlign: "center",
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitLineClamp: "2",
                                WebkitBoxOrient: "vertical"
                            },
                            children: title !== null && title !== void 0 ? title : ad.title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            style: {
                                backgroundColor: "transparent",
                                color: "#ef233c",
                                display: "flex",
                                alignItems: "center",
                                fontSize: "22px",
                                padding: "3px 8px"
                            },
                            onClick: function(e) {
                                e.preventDefault();
                                setVisible(false);
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* IoCloseCircleOutline */.Jvf, {})
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var ads_StickyAdBottom = (StickyAdBottom);

;// CONCATENATED MODULE: ./src/features/ads/ad_selection.js









function AdSelection(param) {
    var _ads = param.ads, ads = _ads === void 0 ? [] : _ads, location = param.location, className = param.className, _Wrapper = param.Wrapper, Wrapper = _Wrapper === void 0 ? false : _Wrapper, wrapperClassName = param.wrapperClassName, wrapperStyle = param.wrapperStyle, style = param.style, _showIfEmpty = param.showIfEmpty, showIfEmpty = _showIfEmpty === void 0 ? false : _showIfEmpty, AdRender = param.AdRender;
    var _position, _position1;
    var adItems = ads.filter(function(a) {
        return a.location === location;
    }).sort(function(a, b) {
        return Number((_position = a.position) !== null && _position !== void 0 ? _position : 0) - Number((_position1 = b.position) !== null && _position1 !== void 0 ? _position1 : 0);
    }).map(function(a) {
        var adProps = [];
        switch(a.content_type){
            case "NEWS_BY_SERVICE":
            case "NEWS_BY_ID":
                {
                    if (!a.news) return null;
                    if (!Array.isArray(a.news)) a.news = [
                        a.news
                    ];
                    adProps = a.news.filter(Boolean).map(function(news) {
                        return {
                            src: (0,utils_news/* thumbnailSrc */.xX)(news.thumbnail),
                            href: (0,utils/* generateUrl */.nu)(news, "news"),
                            title: news.title,
                            nofollow: a.nofollow,
                            id: news.id
                        };
                    });
                }
                break;
            case "MEDIA":
                {
                    adProps = [
                        {
                            href: a.url,
                            title: a.content,
                            nofollow: a.nofollow,
                            displayStyle: a.displayStyle,
                            src: (0,utils_news/* thumbnailSrc */.xX)({
                                file: a.file
                            })
                        }
                    ];
                }
                break;
            case "LINK":
                {
                    var _content;
                    adProps = [
                        {
                            href: a.url,
                            title: (_content = a.content) !== null && _content !== void 0 ? _content : a.title,
                            nofollow: a.nofollow
                        }
                    ];
                }
                break;
            case "PROVIDER":
            case "IFRAME":
                {
                    adProps = [
                        {
                            content: a.content
                        }
                    ];
                }
                break;
        }
        if (AdRender) return adProps.map(function(adProp) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AdRender, (0,_object_spread/* default */.Z)({}, adProp), adProp.id);
        });
        // if (React.isValidElement(adRender))
        //     return adProps.map((adProp) => React.cloneElement(adRender, null, adProp))
        if (a.location === "news_sticky_side" && ![
            "PROVIDER",
            "IFRAME"
        ].includes(a.content_type)) {
            var ref, ref1, ref2, ref3;
            var style1 = {};
            if (a.location.includes("sticky_side") && ((ref = a.cssStyle) === null || ref === void 0 ? void 0 : ref.right)) style1.right = (ref1 = a.cssStyle) === null || ref1 === void 0 ? void 0 : ref1.right;
            if (a.location.includes("sticky_side") && ((ref2 = a.cssStyle) === null || ref2 === void 0 ? void 0 : ref2.bottom)) style1.bottom = (ref3 = a.cssStyle) === null || ref3 === void 0 ? void 0 : ref3.bottom;
            return adProps.map(function(adProp) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ads_StickyAd, {
                    imageSrc: adProp.src,
                    href: adProp.href,
                    title: adProp.title,
                    orientation: "horizontal",
                    style: style1
                }, a.id);
            });
        }
        if ((a.location.includes("sticky_bottom") || a.location.includes("sticky_top")) && ![
            "PROVIDER",
            "IFRAME"
        ].includes(a.content_type)) {
            var ref4, ref5, ref6, ref7;
            var style2 = {};
            if (a.location.includes("sticky_top") && ((ref4 = a.cssStyle) === null || ref4 === void 0 ? void 0 : ref4.top)) style2.top = (ref5 = a.cssStyle) === null || ref5 === void 0 ? void 0 : ref5.top;
            if (a.location.includes("sticky_bottom") && ((ref6 = a.cssStyle) === null || ref6 === void 0 ? void 0 : ref6.bottom)) style2.bottom = (ref7 = a.cssStyle) === null || ref7 === void 0 ? void 0 : ref7.bottom;
            var _displayStyle;
            return adProps.map(function(adProp) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ads_StickyAdBottom, {
                    position: a.location.includes("sticky_top") ? "top" : "bottom",
                    href: adProp.href,
                    title: adProp.title,
                    imgSrc: adProp.src,
                    displayStyle: (_displayStyle = a.displayStyle) !== null && _displayStyle !== void 0 ? _displayStyle : "media_text",
                    style: style2
                }, a.id);
            });
        }
        return adProps.map(function(adProp) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: className,
                "data-adtitle": a.title,
                children: [
                    (a.content_type === "PROVIDER" || a.content_type === "IFRAME") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProviderAd, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, adProp), {
                        style: style
                    })),
                    a.content_type === "LINK" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkAd, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, adProp), {
                        style: style
                    })),
                    a.content_type === "MEDIA" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MediaAd, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, adProp), {
                        style: style
                    }))
                ]
            }, a.id);
        });
    });
    if (adItems.length === 0 && !showIfEmpty) return null;
    if (Wrapper) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        children: adItems
    });
    if (Wrapper === false) return adItems;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        style: wrapperStyle,
        className: wrapperClassName,
        children: adItems
    });
}
function ProviderAd(param) {
    var _content = param.content, content = _content === void 0 ? "" : _content;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: "providerads",
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
}
function LinkAd(param) {
    var _nofollow = param.nofollow, nofollow = _nofollow === void 0 ? true : _nofollow, _href = param.href, href = _href === void 0 ? "" : _href, _title = param.title, title = _title === void 0 ? "" : _title, ad = param.ad;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Tag */.Vp, {
        href: href !== null && href !== void 0 ? href : ad.href,
        nofollow: nofollow !== null && nofollow !== void 0 ? nofollow : ad.nofollow,
        target: "_blank",
        children: title !== null && title !== void 0 ? title : ad.href
    });
}
function MediaAd(param) {
    var _href = param.href, href = _href === void 0 ? "" : _href, _nofollow = param.nofollow, nofollow = _nofollow === void 0 ? true : _nofollow, _src = param.src, src = _src === void 0 ? "" : _src, _displayStyle = param.displayStyle, displayStyle = _displayStyle === void 0 ? "image_only" : _displayStyle, _title = param.title, title = _title === void 0 ? "" : _title, style = param.style;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
        href: href,
        rel: nofollow ? "nofollow" : "follow",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    src: src,
                    alt: title !== null && title !== void 0 ? title : "تبلیغ",
                    loading: "lazy",
                    style: style
                }),
                displayStyle === "image_text" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: title
                })
            ]
        })
    });
}


/***/ }),

/***/ 44534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20442);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);



function Button(param) {
    var children = param.children, _type = param.type, type = _type === void 0 ? "default" : _type, btnColor = param.btnColor, size = param.size, style = param.style, onClick = param.onClick;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__.u)();
    var color = theme === null || theme === void 0 ? void 0 : theme.colors;
    var primary = {
        default: {
            color: color.white,
            bgColor: color.primary
        },
        outlined: {
            color: color.primary,
            hoverBgColor: color.primary
        }
    };
    var buttonSize = function(bSize) {
        switch(bSize){
            case "x-small":
                return "\n                    font-size: ".concat(theme.fontSize.xs, ";\n                    padding: 0.25rem;\n                ");
            case "small":
                return "\n                    font-size: ".concat(theme.fontSize.sm, ";\n                    padding: 0.25rem 0.5rem;\n                ");
            case "medium":
                return "font-size: ".concat(theme.fontSize.base, "; \n                        padding: 0.5rem 2rem;\n                ");
            case "large":
                return "\n                    font-size: ".concat(theme.fontSize.lg, "; \n                    padding: 1rem 3rem;\n                ");
            default:
                return "\n                    font-size: ".concat(theme.fontSize.base, "; \n                    padding: 0.5rem 2rem;\n                ");
        }
    };
    var buttonStyle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)("display:flex;justify-content:center;align-items:center;", buttonSize(size), ";", type === "default" && "color: ".concat(((ref = color[btnColor]) === null || ref === void 0 ? void 0 : (ref1 = ref.default) === null || ref1 === void 0 ? void 0 : ref1.color) || (primary === null || primary === void 0 ? void 0 : (ref2 = primary.default) === null || ref2 === void 0 ? void 0 : ref2.color)), ";", type === "default" && "background-color: ".concat(((ref3 = color[btnColor]) === null || ref3 === void 0 ? void 0 : ref3.default.bgColor) || (primary === null || primary === void 0 ? void 0 : (ref4 = primary.default) === null || ref4 === void 0 ? void 0 : ref4.bgColor)), ";", type === "outlined" && "color: ".concat(((ref5 = color[btnColor]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.outlined) === null || ref6 === void 0 ? void 0 : ref6.color) || (primary === null || primary === void 0 ? void 0 : (ref7 = primary.outlined) === null || ref7 === void 0 ? void 0 : ref7.color)), ";", type === "outlined" && "background-color: transparent", ";", type === "outlined" && "border: 1px solid ".concat(((ref8 = color[btnColor]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.outlined) === null || ref9 === void 0 ? void 0 : ref9.color) || (primary === null || primary === void 0 ? void 0 : (ref10 = primary.outlined) === null || ref10 === void 0 ? void 0 : ref10.color)), ";&:hover{filter:contrast(120%) brightness(120%);", type === "outlined" && "filter: drop-shadow(0 0 4px ".concat(((ref11 = color[btnColor]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.outlined) === null || ref12 === void 0 ? void 0 : ref12.hoverBgColor) || (primary === null || primary === void 0 ? void 0 : (ref13 = primary.outlined) === null || ref13 === void 0 ? void 0 : ref13.hoverBgColor)), ");}", style);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("button", {
        onClick: onClick,
        css: buttonStyle,
        children: children
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 84015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20442);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var _base_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82843);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74614);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44534);








function SearchModal(param) {
    var trigger = param.trigger;
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().push;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)([
        "common"
    ]).t;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), val = ref[0], setVal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), msg = ref1[0], setMsg = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("q"), query = ref2[0], setQuery = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), visible = ref3[0], setVisible = ref3[1];
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.u)();
    var inputStyle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("width:100%;background-color:transparent;outline:none;border-bottom:2px solid #343434;padding:1rem;color:#eeeeee;font-size:2rem;");
    var mainStyle = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("width:80%;display:flex;flex-direction:column;gap:2rem;align-items:center;button{width:10rem;}");
    var searchFn = function() {
        if (!val) {
            setMsg("لطفاً یک عبارت تایپ کنید");
            return;
        }
        setVisible(false);
        setVal("");
        push("/search?".concat(query, "=").concat(val || ""), undefined, {
            shallow: false
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(trigger, {
                onClick: function() {
                    setVisible(true);
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
                visible: visible,
                onClose: function() {
                    return setVisible(false);
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                    css: mainStyle,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("input", {
                            css: inputStyle,
                            type: "search",
                            id: "mySearch",
                            name: "q",
                            placeholder: t("جستجو کنید", {
                                ns: "common"
                            }) + "...",
                            value: val,
                            onChange: function(e) {
                                setVal(e.target.value);
                            },
                            onKeyDown: function(e) {
                                if (e.code !== "Enter") return;
                                searchFn();
                            }
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
                            style: {
                                display: "flex",
                                gap: "1rem",
                                justifyContent: "flex-start",
                                alignSelf: "flex-start",
                                alignItems: "center",
                                color: "white",
                                flexWrap: "wrap"
                            },
                            children: [
                                t("جستجو در", {
                                    ns: "common"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                                    style: {
                                        display: "inline-flex",
                                        backgroundColor: query === "q" ? theme.colors.primary : "transparent",
                                        border: "1px solid ".concat(theme.colors.primary),
                                        padding: "2px 5px",
                                        borderRadius: "5px",
                                        color: theme.colors.white,
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        return setQuery("q");
                                    },
                                    children: t("عنوان", {
                                        ns: "common"
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                                    style: {
                                        display: "inline-flex",
                                        backgroundColor: query === "tag" ? theme.colors.primary : "transparent",
                                        border: "1px solid ".concat(theme.colors.primary),
                                        padding: "2px 5px",
                                        borderRadius: "5px",
                                        color: theme.colors.white,
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        return setQuery("tag");
                                    },
                                    children: t("برچسب", {
                                        ns: "common"
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                                    style: {
                                        display: "inline-flex",
                                        backgroundColor: query === "author" ? theme.colors.primary : "transparent",
                                        border: "1px solid ".concat(theme.colors.primary),
                                        padding: "2px 5px",
                                        borderRadius: "5px",
                                        color: theme.colors.white,
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        return setQuery("author");
                                    },
                                    children: t("نویسنده", {
                                        ns: "common"
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
                                    style: {
                                        display: "inline-flex",
                                        backgroundColor: query === "content" ? theme.colors.primary : "transparent",
                                        border: "1px solid ".concat(theme.colors.primary),
                                        padding: "2px 5px",
                                        borderRadius: "5px",
                                        color: theme.colors.white,
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        return setQuery("content");
                                    },
                                    children: t("متن", {
                                        ns: "common"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            onClick: function() {
                                searchFn();
                            },
                            children: t("جستجو", {
                                ns: "common"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("span", {
                            style: {
                                color: "red"
                            },
                            children: msg
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SearchModal);


/***/ }),

/***/ 57412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "an": function() { return /* reexport */ page_builder_AdScriptUrl; },
  "JG": function() { return /* reexport */ page_builder_BlogPost; },
  "sg": function() { return /* reexport */ page_builder_Column; },
  "FZ": function() { return /* reexport */ page_builder_FooterAbout; },
  "It": function() { return /* reexport */ page_builder_HeaderMiddleBar; },
  "rJ": function() { return /* reexport */ page_builder_HeaderTopBar; },
  "Vw": function() { return /* reexport */ page_builder_HomeCarousel; },
  "Ee": function() { return /* reexport */ Image/* default */.Z; },
  "v$": function() { return /* reexport */ page_builder_InfoGrid; },
  "sr": function() { return /* reexport */ page_builder_ItemList; },
  "fG": function() { return /* reexport */ page_builder_LinkBox; },
  "nf": function() { return /* reexport */ page_builder_LinkItem; },
  "Y6": function() { return /* reexport */ page_builder_PostCardH; },
  "Il": function() { return /* reexport */ page_builder_ProductCard; },
  "GM": function() { return /* reexport */ page_builder_ProductCarousel; },
  "lZ": function() { return /* reexport */ page_builder_ProductTab; },
  "Qg": function() { return /* reexport */ page_builder_RecentPost; },
  "IX": function() { return /* reexport */ page_builder_RelatedCarousel; },
  "$0": function() { return /* reexport */ page_builder_Section; },
  "WG": function() { return /* reexport */ SocialLinks/* default */.Z; },
  "Vp": function() { return /* reexport */ page_builder_Tag; },
  "fJ": function() { return /* reexport */ page_builder_ThemeCard; },
  "oV": function() { return /* reexport */ page_builder_ThemeFooter; },
  "$i": function() { return /* reexport */ page_builder_ThemeHeader; },
  "VH": function() { return /* reexport */ page_builder_UsefulLinks; }
});

// UNUSED EXPORTS: AddressIcon, Button, Checkbox, OrderForm, ServiceBox, SidebarList

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./src/features/base-ui/index.js + 31 modules
var base_ui = __webpack_require__(82843);
;// CONCATENATED MODULE: ./src/features/page-builder/ThemeCard.js




function ThemeCard(param) {
    var title = param.title, uptitle = param.uptitle, content = param.content, action = param.action, bgImageUrl = param.bgImageUrl, _style = param.style, style = _style === void 0 ? {
        bgColor: "",
        color: ""
    } : _style;
    var cardStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;align-self:center;justify-content:center;flex-wrap:wrap;min-height:500px;padding:3.75rem;background-color:", style.bgColor, ";", bgImageUrl && "background-image: url(".concat(bgImageUrl, ")"), ";background-repeat:no-repeat;background-size:cover;color:", style.color, ";.cardUptitle{margin-bottom:0;}.cardTitle,.content{margin-bottom:20px;}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: cardStyle,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                fontSize: "2.2rem",
                color: style.color,
                type: "h4",
                className: "cardUptitle",
                children: uptitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                fontSize: "3.2rem",
                color: style.color,
                type: "h3",
                className: "cardTitle",
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                color: style.color,
                type: "p",
                className: "content",
                children: content
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "action",
                children: action
            })
        ]
    });
}
/* harmony default export */ var page_builder_ThemeCard = (ThemeCard);

// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
;// CONCATENATED MODULE: ./src/features/page-builder/Column.js



function Column(param) {
    var _xs = param.xs, xs = _xs === void 0 ? 24 : _xs, _sm = param.sm, sm = _sm === void 0 ? 24 : _sm, _md = param.md, md = _md === void 0 ? 12 : _md, _lg = param.lg, lg = _lg === void 0 ? 8 : _lg, _xl = param.xl, xl = _xl === void 0 ? 8 : _xl, children = param.children, style = param.style, className = param.className;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(col/* default */.Z, {
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl,
        style: style,
        className: className,
        children: children
    });
}
/* harmony default export */ var page_builder_Column = (Column);

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js + 1 modules
var emotion_element_f0de968e_browser_esm = __webpack_require__(20442);
// EXTERNAL MODULE: ./src/features/base-ui/Utility.js
var Utility = __webpack_require__(12774);
;// CONCATENATED MODULE: ./src/features/page-builder/Section.js



function Section(param) {
    var children = param.children, backgroundImage = param.backgroundImage, backgroundColor = param.backgroundColor, className = param.className, _parallax = param.parallax, parallax = _parallax === void 0 ? false : _parallax, _noPadding = param.noPadding, noPadding = _noPadding === void 0 ? false : _noPadding, style = param.style;
    var ref;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("section", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(backgroundColor && "background-color: ".concat((ref = theme.colors) === null || ref === void 0 ? void 0 : ref[backgroundColor]), ";background-repeat:no-repeat;", backgroundImage && "background-image: url(".concat(backgroundImage, "); background-size: cover; background-position: top;"), ";", parallax && "background-attachment: fixed;", ";", !noPadding && "\n                    padding: 1rem;\n                    ".concat((0,Utility/* MediaQuery */.zP)("lg", "min"), " {\n                        padding: 0.5rem 5rem;\n                    }\n                    ").concat((0,Utility/* MediaQuery */.zP)("xl", "min"), " {\n                        padding: 0.5rem 10rem;\n                    }\n                    ").concat((0,Utility/* MediaQuery */.zP)("xxl", "min"), " {\n                        padding: 0.5rem 20rem;\n                    }\n                "), " ", style),
        className: className,
        children: children
    });
}
/* harmony default export */ var page_builder_Section = (Section);

// EXTERNAL MODULE: ./src/hooks/dataProvider/index.js + 1 modules
var dataProvider = __webpack_require__(46766);
// EXTERNAL MODULE: ./src/features/webpage/Nav.jsx
var Nav = __webpack_require__(32238);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./src/hooks/useBreakpoints.js
var useBreakpoints = __webpack_require__(22807);
// EXTERNAL MODULE: ./src/features/page-builder/SearchModal.js
var SearchModal = __webpack_require__(84015);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./config.json
var config = __webpack_require__(51181);
// EXTERNAL MODULE: ./src/features/ads/ad_selection.js + 2 modules
var ad_selection = __webpack_require__(12547);
;// CONCATENATED MODULE: ./src/features/page-builder/ThemeHeader.js














function ThemeHeader(param) {
    var _topBar = param.topBar, topBar = _topBar === void 0 ? true : _topBar, style = param.style;
    var ref, ref1;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var locale = (0,router.useRouter)().locale;
    var backgroundColor = theme.colors.nav.backgroundColor;
    var breakpoint = (0,useBreakpoints/* default */.Z)();
    var ref2 = (0,react.useState)(false), mobileMenuVisible = ref2[0], setMobileMenuVisible = ref2[1];
    var ref3 = (0,dataProvider/* useDataProvider */.x5)(), data = ref3.data, setData = ref3.setData;
    (0,react.useEffect)(function() {
        setData({
            visible: false
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var headerNavStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:none;justify-content:space-between;align-items:center;border-bottom:1px solid rgba(0,0,0,0.08);background-color:", backgroundColor, ";.extra-nav{padding:20px 0 16px 0px;position:relative;", [
        "ar",
        "fa"
    ].indexOf(locale) !== -1 ? "border-right: 1px solid rgba(0, 0, 0, 0.1);" : "border-left: 1px solid rgba(0, 0, 0, 0.1);", "            .extra-cell{display:inline-block;", [
        "ar",
        "fa"
    ].indexOf(locale) !== -1 ? "margin-right: 10px;" : "margin-left: 10px;", "                svg{font-size:24px;color:", theme.colors.primary, ";font-weight:100;}}}padding:0 1rem;.social-icons{", [
        "ar",
        "fa"
    ].indexOf(locale) !== -1 ? "margin-right: auto;" : "margin-left: auto;", "            .link a{color:", theme.colors.lightGray, ";&:hover{color:", theme.colors.secondary, ";}}}", (0,Utility/* MediaQuery */.zP)("lg", "min"), "{padding:0rem 5rem;display:flex;}", (0,Utility/* MediaQuery */.zP)("xl", "min"), "{padding:0rem 10rem;}", (0,Utility/* MediaQuery */.zP)("xxl", "min"), "{padding:0rem 20rem;}", style);
    var ref4;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("header", {
        children: [
            !breakpoint.xs && topBar && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_HeaderTopBar, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_HeaderMiddleBar, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "header-nav",
                css: headerNavStyle,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Nav/* default */.Z, {
                        items: data === null || data === void 0 ? void 0 : data.menuItems,
                        visible: mobileMenuVisible,
                        onClose: function() {
                            return setMobileMenuVisible(false);
                        },
                        type: "mobile"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "nav",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Nav/* default */.Z, {
                            items: data === null || data === void 0 ? void 0 : data.menuItems
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ad_selection/* default */.ZP, {
                        ads: (ref4 = data === null || data === void 0 ? void 0 : data.siteAds) !== null && ref4 !== void 0 ? ref4 : [],
                        location: "site_header_menu",
                        style: {
                            maxHeight: 60,
                            objectFit: "contain"
                        },
                        Wrapper: function(param) {
                            var children = param.children;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                style: {
                                    display: "inline-flex",
                                    gap: 5,
                                    alignItems: "center",
                                    maxHeight: "100%",
                                    overflow: "hidden",
                                    flex: 1,
                                    justifyContent: "flex-end"
                                },
                                children: children
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "social-icons",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialLinks/* default */.Z, {
                            socials: config === null || config === void 0 ? void 0 : (ref = config.texts) === null || ref === void 0 ? void 0 : (ref1 = ref.social) === null || ref1 === void 0 ? void 0 : ref1.value,
                            style: "justify-content: center;"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "extra-nav",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "extra-cell",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchModal/* default */.Z, {
                                trigger: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                    id: "quik-search-btn",
                                    type: "button",
                                    className: "site-button-link",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineSearch */.RB5, {})
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var page_builder_ThemeHeader = (ThemeHeader);

// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
;// CONCATENATED MODULE: ./src/features/page-builder/HeaderTopBar.js






function HeaderTopBar() {
    var topBarStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid rgba(0,0,0,0.08);background-color:#ffffff;.left-items ul li{display:inline-block;margin:0 0.5rem;font-size:1rem;}padding:0.5rem 1rem;", (0,Utility/* MediaQuery */.zP)("lg", "min"), "{padding:0.5rem 5rem;}", (0,Utility/* MediaQuery */.zP)("xl", "min"), "{padding:0.5rem 10rem;}", (0,Utility/* MediaQuery */.zP)("xxl", "min"), "{padding:0.5rem 20rem;}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: topBarStyle,
        className: "top-bar",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "left-items",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                href: "/",
                                children: "About Us"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(divider/* default */.Z, {
                            type: "vertical"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                href: "/",
                                children: "Refund Policy"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(divider/* default */.Z, {
                            type: "vertical"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                href: "/",
                                children: "Help Desk"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "right-items",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                    href: "/",
                    children: "GET A QUOTE"
                })
            })
        ]
    });
}
/* harmony default export */ var page_builder_HeaderTopBar = (HeaderTopBar);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/features/base-ui/Image.js
var Image = __webpack_require__(94477);
;// CONCATENATED MODULE: ./src/features/page-builder/ServiceBox.js






function ServiceBox(param) {
    var icon = param.icon, title = param.title, subtitle = param.subtitle;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var locale = (0,router.useRouter)().locale;
    var serviceStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".subtitle{color:", theme.colors.secGray, ";}svg{position:absolute;", [
        "ar",
        "fa"
    ].indexOf(locale) !== -1 ? "right: -45px;" : "left: -45px;", "            font-size:38px;line-height:38px;color:", theme.colors.primary, ";font-weight:100;top:2px;}", (0,Utility/* MediaQuery */.zP)("lg", "min"), "{.typography{font-size:0.9rem;}}", (0,Utility/* MediaQuery */.zP)("xl", "min"), "{.typography{font-size:1.1rem;}}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: serviceStyle,
        children: [
            icon,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                type: "h5",
                className: "title",
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                className: "subtitle",
                children: subtitle
            })
        ]
    });
}
/* harmony default export */ var page_builder_ServiceBox = (ServiceBox);

// EXTERNAL MODULE: ./node_modules/react-icons/gi/index.esm.js
var gi_index_esm = __webpack_require__(2585);
// EXTERNAL MODULE: ./src/features/webpage/index.js + 10 modules
var webpage = __webpack_require__(21648);
// EXTERNAL MODULE: ./src/features/page-builder/SocialLinks.js
var SocialLinks = __webpack_require__(95209);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
;// CONCATENATED MODULE: ./src/features/page-builder/HeaderMiddleBar.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "",
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "",
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var COMMON_ICONS = {
    phone: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlinePhone */.Nhm, {}),
    time: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineFieldTime */.QRz, {}),
    pin: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlinePushpin */.bI9, {}),
    mobile: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineMobile */.j_0, {}),
    mail: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineMail */.Dme, {}),
    whatsapp: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(io5_index_esm/* IoLogoWhatsapp */.ff9, {})
};
function HeaderMiddleBar() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var ref12 = (0,react.useState)(false), mobileMenuVisible = ref12[0], setMobileMenuVisible = ref12[1];
    var ref13 = (0,dataProvider/* useDataProvider */.x5)(), data = ref13.data, setData = ref13.setData;
    var locale = (0,router.useRouter)().locale;
    (0,react.useEffect)(function() {
        setData({
            visible: false
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var middleBarStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;justify-content:space-between;align-items:center;flex-grow:1;flex-wrap:wrap;border-bottom:1px solid rgba(0,0,0,0.08);background-color:#ffffff;.service-list{display:none;}.service-list ul,.service-list-mobile ul{display:flex;align-items:center;}.service-list-mobile{", [
        "ar",
        "fa"
    ].indexOf(locale) !== -1 ? "padding-right: 40px;" : "padding-left: 40px;", "            border-top:1px solid #eee;width:100%;}.service-list-mobile ul{flex-wrap:wrap;justify-content:space-between;width:100%;margin:0 auto;}.service-list-mobile ul li{margin:0.5rem 1.5rem !important;svg{font-size:28px;}}.service-list-mobile ul li:last-child{margin:0.5rem auto !important;}.service-list ul li,.service-list-mobile ul li{position:relative;display:inline-block;margin:0 2rem;}.left-side{margin-right:auto;display:flex;gap:1rem;}.service-list{margin-right:-2rem;}padding:1rem 1rem;.extra-nav{padding:20px 0 16px 0px;position:relative;border-left:1px solid rgba(0,0,0,0.1);.extra-cell{display:inline-block;margin-left:10px;svg{font-size:24px;color:", theme.colors.primary, ";font-weight:100;}}}.mobile-navigation{display:block;}.site-logo{flex-basis:40%;}.actionButton{.link a{padding:0.25rem 0.5rem;background-color:", theme.colors.primary, ";color:#fff;}}.service-list-mobile{display:flex;.social-icons{padding-top:1rem;border-top:1px solid #eee;width:100%;", [
        "ar",
        "fa"
    ].indexOf(locale) !== -1 ? "right: -20px;" : "left: -20px;", "                .link a{color:", theme.colors.primary, ";&:hover{color:", theme.colors.secondary, ";}}}}", (0,Utility/* MediaQuery */.zP)("md", "min"), "{.service-list-mobile ul li:last-child{margin:0.5rem 0 !important;}}", (0,Utility/* MediaQuery */.zP)("lg", "min"), "{.site-logo{flex-basis:20%;}.actionButton{.link a{padding:1rem 2rem;}}.mobile-navigation{display:none;}padding:1rem 5rem;.service-list{display:block;}.left-side,.service-list-mobile{display:none;}}", (0,Utility/* MediaQuery */.zP)("xl", "min"), "{padding:1rem 10rem;}", (0,Utility/* MediaQuery */.zP)("xxl", "min"), "{padding:1rem 20rem;}");
    var ref14, ref15;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: middleBarStyle,
        className: "middle-bar",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "site-logo",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                    href: "/",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                        noStyle: true,
                        src: "/img/project/logo.png",
                        width: (ref14 = (ref = config.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.logo) === null || ref2 === void 0 ? void 0 : ref2.width) !== null && ref14 !== void 0 ? ref14 : 250,
                        height: (ref15 = (ref3 = config.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.logo) === null || ref5 === void 0 ? void 0 : ref5.height) !== null && ref15 !== void 0 ? ref15 : 80,
                        alt: "site logo",
                        objectFit: "contain"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "left-side",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "extra-nav",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "extra-cell",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SearchModal/* default */.Z, {
                                trigger: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                    id: "quik-search-btn",
                                    type: "button",
                                    className: "site-button-link",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineSearch */.RB5, {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                        className: "flex-item lg:hidden hamburger-menu",
                        onClick: function() {
                            setMobileMenuVisible(true);
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(gi_index_esm/* GiHamburgerMenu */.vHB, {
                            className: "text-4xl"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "service-list",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                    children: config === null || config === void 0 ? void 0 : (ref6 = config.texts) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.header_items) === null || ref7 === void 0 ? void 0 : ref7.map(function(i, idx) {
                        if (i.type === "button") {
                            var _css;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                style: {
                                    margin: "0 1rem"
                                },
                                css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), (_css = i.css) !== null && _css !== void 0 ? _css : ""),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "actionButton",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                        href: i.href,
                                        children: i.title
                                    })
                                })
                            }, idx);
                        }
                        var _css1;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            css: (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), (_css1 = i.css) !== null && _css1 !== void 0 ? _css1 : ""),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_ServiceBox, {
                                icon: COMMON_ICONS[i.icon],
                                title: i.title,
                                subtitle: i.subtitle
                            })
                        }, idx);
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "mobile-navigation",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".mobile-nav{background-color:", theme.colors.darkGray, " !important;.accordion-title,a span{outline-color:", theme.colors.lighter, ";color:", theme.colors.darkGray, ";background-color:", theme.colors.lighterGray, ";}.accordion-content .link{border-color:", theme.colors.primary, ";}}"),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(webpage/* Nav */.JL, {
                    items: data === null || data === void 0 ? void 0 : data.menuItems,
                    visible: mobileMenuVisible,
                    onClose: function() {
                        return setMobileMenuVisible(false);
                    },
                    type: "mobile"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "service-list-mobile",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                    children: [
                        config === null || config === void 0 ? void 0 : (ref8 = config.texts) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.header_items) === null || ref9 === void 0 ? void 0 : ref9.map(function(i, idx) {
                            if (i.type === "button") {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                    style: {
                                        margin: "0 1rem"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        className: "actionButton",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                                            href: i.href,
                                            children: i.title
                                        })
                                    })
                                }, idx);
                            }
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_ServiceBox, {
                                    icon: COMMON_ICONS[i.icon],
                                    subtitle: i.title
                                })
                            }, idx);
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                            className: "social-icons",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialLinks/* default */.Z, {
                                socials: config === null || config === void 0 ? void 0 : (ref10 = config.texts) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.social) === null || ref11 === void 0 ? void 0 : ref11.value,
                                style: "justify-content: center;"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var page_builder_HeaderMiddleBar = (HeaderMiddleBar);

// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
;// CONCATENATED MODULE: ./src/features/page-builder/ThemeFooter.js




function ThemeFooter() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("footer", {
        style: {
            borderTop: "1px solid rgba(0, 0, 0, 0.08)"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(row/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_Column, {
                    xs: {
                        span: 24,
                        order: 3
                    },
                    md: {
                        span: 24,
                        order: 3
                    },
                    lg: {
                        span: 8,
                        order: 1
                    },
                    xl: 8,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_FooterAbout, {
                        src: "/img/project/logo.png",
                        latest: false
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_Column, {
                    xs: {
                        span: 24,
                        order: 1
                    },
                    md: {
                        span: 24,
                        order: 1
                    },
                    lg: {
                        span: 8,
                        order: 2
                    },
                    xl: 8,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_UsefulLinks, {})
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_Column, {
                    xs: {
                        span: 24,
                        order: 2
                    },
                    md: {
                        span: 24,
                        order: 2
                    },
                    lg: {
                        span: 8,
                        order: 3
                    },
                    xl: 8,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_RecentPost, {})
                })
            ]
        })
    });
}
/* harmony default export */ var page_builder_ThemeFooter = (ThemeFooter);

;// CONCATENATED MODULE: ./src/features/page-builder/AddressIcon.js



function AddressIcon(param) {
    var icon = param.icon, content = param.content;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;padding:0.5rem 0;align-items:center;gap:1rem;svg{font-size:28px;line-height:28px;color:", theme.colors.primary, ";font-weight:100;}.content{font-weight:600;color:", theme.colors.secGray, ";}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: style,
        children: [
            icon,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "content",
                children: content
            })
        ]
    });
}
/* harmony default export */ var page_builder_AddressIcon = (AddressIcon);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(74614);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/features/page-builder/FooterAbout.js










function FooterAbout(param) {
    var src = param.src, touchInfo = param.touchInfo, social = param.social, _lineClamp = param.lineClamp, lineClamp = _lineClamp === void 0 ? 6 : _lineClamp, _more = param.more, more = _more === void 0 ? true : _more, _latest = param.latest, latest = _latest === void 0 ? true : _latest, cutsomContent = param.cutsomContent, style = param.style;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var t = (0,esm/* useTranslation */.$G)([
        "common"
    ]).t;
    var enhancedStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;padding:3rem;height:100%;.site-logo{margin-bottom:1rem;}", style);
    var ref11, ref12;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: enhancedStyle,
        children: [
            src && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "site-logo",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                    noStyle: true,
                    src: src,
                    width: (ref11 = (ref = config.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.logoFooter) === null || ref2 === void 0 ? void 0 : ref2.width) !== null && ref11 !== void 0 ? ref11 : 250,
                    height: (ref12 = (ref3 = config.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.logoFooter) === null || ref5 === void 0 ? void 0 : ref5.height) !== null && ref12 !== void 0 ? ref12 : 80,
                    objectFit: "contain",
                    alt: "site logo"
                })
            }),
            cutsomContent,
            "-------------------------",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                type: "p",
                color: theme === null || theme === void 0 ? void 0 : (ref6 = theme.colors) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.websiteFooter) === null || ref7 === void 0 ? void 0 : ref7.color,
                lineClamp: lineClamp,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    dangerouslySetInnerHTML: {
                        __html: (ref8 = config.texts) === null || ref8 === void 0 ? void 0 : ref8.footer_about
                    }
                })
            }),
            latest && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                href: "/latest",
                children: t("آخرین اخبار", {
                    ns: "news"
                })
            }),
            more && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                href: "/about",
                style: {
                    textTransform: "capitalize"
                },
                children: t("درباره ما", {
                    ns: "common"
                })
            }),
            (config === null || config === void 0 ? void 0 : (ref9 = config.integrations) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.namad) === null || ref10 === void 0 ? void 0 : ref10.code) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        id: "div_eRasanehTrustseal_".concat(config.integrations.namad.code)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                        id: "namad_src",
                        src: "https://trustseal.e-rasaneh.ir/trustseal.js"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                        id: "namad_init",
                        dangerouslySetInnerHTML: {
                            __html: "window.addEventListener('load', function() {\n  eRasaneh_Trustseal(".concat(config.integrations.namad.code, ", false);\n})")
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Divider */.iz, {
                width: "100%"
            }),
            touchInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_AddressIcon, {
                        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlinePushpin */.bI9, {}),
                        content: touchInfo === null || touchInfo === void 0 ? void 0 : touchInfo.address
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_AddressIcon, {
                        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineMobile */.j_0, {}),
                        content: touchInfo === null || touchInfo === void 0 ? void 0 : touchInfo.tel
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_AddressIcon, {
                        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* AiOutlineMail */.Dme, {}),
                        content: touchInfo === null || touchInfo === void 0 ? void 0 : touchInfo.mail
                    })
                ]
            }),
            social
        ]
    });
}
/* harmony default export */ var page_builder_FooterAbout = (FooterAbout);

;// CONCATENATED MODULE: ./src/features/page-builder/UsefulLinks.js





function UsefulLinks() {
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:3rem;.title{margin-bottom:2rem;}ul{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));list-style:inside;li{font-size:1rem;font-weight:600;padding:0.5rem 0;}}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: style,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                type: "h4",
                className: "title",
                fontWeight: "Semi Bold",
                children: "Usefull Link"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                            href: "/about",
                            children: "About Us"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                            href: "/contact",
                            children: "Contact Us"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        style: {
                            listStyle: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                            external: true,
                            rel: "nofollow",
                            href: "https://www.instagram.com/nour_alzomorod.co",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(io5_index_esm/* IoLogoInstagram */.oVe, {}),
                                    " Follow on Instagram"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        style: {
                            listStyle: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                            external: true,
                            rel: "nofollow",
                            href: "http://www.linkedin.com/in/nour-alzomorod-9b8b59311",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(io5_index_esm/* IoLogoLinkedin */.gXb, {}),
                                    " Follow on Linkedin"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        style: {
                            listStyle: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                            external: true,
                            rel: "nofollow",
                            href: "https://www.facebook.com/profile.php?id=61559426597641&mibextid=LQQJ4d",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(io5_index_esm/* IoLogoFacebook */.egd, {}),
                                    " Follow on Facebook"
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var page_builder_UsefulLinks = (UsefulLinks);

;// CONCATENATED MODULE: ./src/features/page-builder/RecentPost.js




// import PostCardH from './PostCardH'
function RecentPost() {
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:3rem 3rem 1rem 1rem;.title{margin-bottom:2rem;}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
            type: "h4",
            className: "title",
            fontWeight: "Semi Bold",
            children: "Recent Post"
        })
    });
}
/* harmony default export */ var page_builder_RecentPost = (RecentPost);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/features/page-builder/HomeCarousel.js








function HomeCarousel() {
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var dotStyle = "\n        .dots {\n            position: absolute;\n            display: flex;\n            width: 200px;\n            z-index: 9;\n            bottom: 50px;\n            right: 70px;\n            left: auto;\n            flex-direction: row-reverse;\n            gap: 0.5rem;\n            svg {\n                font-size: 18px;\n                color: #ffffff;\n            }\n            .active svg {\n                fill: #ffffff;\n                background-color: #ffffff;\n                border-radius: 50%;\n            }\n        }\n        ".concat((0,Utility/* MediaQuery */.zP)("sm", "max"), " {\n            .dots {\n                width: 100%;\n                right: auto;\n                justify-content: center;\n            }\n        }\n    ");
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;height:720px;position:relative;.h1{text-shadow:2px 1px 10px #4c4c4c;}.gradient{background:linear-gradient(\n                rgba(0,0,0,0) 0%,rgba(0,0,0,0.45) 100%\n            );width:100%;height:40%;position:absolute;z-index:3;bottom:0;}.overlay{position:absolute;z-index:2;background-color:rgba(0,0,0,0.1);border-color:rgba(0,0,0,0);border-width:0px;background-image:url('img/project/rrdiagonal-line.png');visibility:inherit;transition:none 0s ease 0s;text-align:left;line-height:24px;margin:0px;padding:0px;letter-spacing:0px;font-weight:400;font-size:16px;white-space:nowrap;height:720px;width:100%;opacity:1;transform:matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1);transform-origin:50% 50% 0px;}");
    var textBox = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("max-width:45rem;position:absolute;z-index:9;left:70px;bottom:50px;display:flex;flex-wrap:wrap;.title{flex-basis:100%;text-shadow:0 0 7px black;}.content{flex-basis:65%;text-shadow:0 0 7px black;}.action:{flex-basis:35%;}", (0,Utility/* MediaQuery */.zP)("sm", "max"), "{.h1{font-size:4rem;}left:auto;bottom:auto;top:150px;justify-content:center;.title,.content,.action{flex-basis:80%;text-align:center;justify-content:center;}}");
    var actionStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;gap:0.5rem;align-self:center;.actionButton{border:1px solid #888888;color:", theme.colors.lighterGray, ";border-radius:0;padding:0.5rem;justify-content:center;}.wide{width:13rem;}");
    var carouselSettings = {
        rtl: true,
        loop: true,
        controls: false,
        autoSwitch: true,
        dots: true,
        preview: {
            sm: 1,
            md: 1,
            lg: 1,
            xl: 1,
            xxl: 1
        },
        style: dotStyle
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Carousel */.lr, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, carouselSettings), {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "keen-slider__slide",
                    css: style,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "box",
                            css: textBox,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                                    className: "title",
                                    type: "h1",
                                    fontSize: "5.5rem",
                                    fontWeight: "Bold",
                                    color: "white"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                                    className: "content",
                                    type: "p",
                                    fontSize: "1.1rem",
                                    fontWeight: "Semi Bold",
                                    color: "lightGray"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "action",
                                    css: actionStyle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "gradient"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                            layout: "fill",
                            objectFit: "cover",
                            src: "/img/zeolite/slide-01.jpg?562",
                            priority: true,
                            alt: ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    className: "keen-slider__slide",
                    css: style,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "box",
                            css: textBox,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                                    className: "title",
                                    type: "h1",
                                    fontSize: "5.5rem",
                                    fontWeight: "Bold",
                                    color: "white"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                                    className: "content",
                                    type: "p",
                                    fontSize: "1.1rem",
                                    fontWeight: "Semi Bold",
                                    color: "lightGray"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    className: "action",
                                    css: actionStyle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "gradient"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                            layout: "fill",
                            objectFit: "cover",
                            src: "/img/zeolite/slide-02.jpg?1233",
                            priority: true,
                            alt: ""
                        })
                    ]
                })
            ]
        }))
    });
}
/* harmony default export */ var page_builder_HomeCarousel = (HomeCarousel);

// EXTERNAL MODULE: ./src/utils/index.js + 3 modules
var utils = __webpack_require__(12311);
;// CONCATENATED MODULE: ./src/features/page-builder/ProductCard.js







function ProductCard(param) {
    var entity = param.entity, _type = param.type, type = _type === void 0 ? "product" : _type;
    var ref, ref1, ref2, ref3;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var t = (0,esm/* useTranslation */.$G)([
        "common"
    ]).t;
    if (!entity) return null;
    var productStyle = "\n        height: 100%;\n        border-Radius: 0;\n        .card-body {\n            padding: 0;\n        }\n        .product-content {\n            padding: 1rem;\n            position: relative;\n            height: 250px;\n        }\n        .product-category {\n            padding: 0.5rem 2rem;\n            background-color: ".concat(theme.colors.primary, "; \n            position: absolute;\n            bottom: 10px;\n            color: #ffffff;\n        }\n        .product-image {\n            position: relative;\n        }\n        button {\n            border: 1px solid ").concat(theme.colors.primary, ";\n            color: ").concat(theme.colors.primary, ";\n            border-radius: 0;\n            padding: 0.5rem;\n            justify-content: center;\n            width: 90%;\n            margin: 0 auto;\n            position: absolute;\n            bottom: 15px;\n        }\n    ");
    var ref4;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Card */.Zb, {
        bordered: true,
        style: productStyle,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "product-image",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                        src: (entity === null || entity === void 0 ? void 0 : (ref = entity.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.hash) && "/api/filedb/".concat(entity === null || entity === void 0 ? void 0 : entity.thumbnail.file.hash, ".").concat(entity === null || entity === void 0 ? void 0 : entity.thumbnail.file.ext),
                        width: 1280,
                        height: 720,
                        objectFit: "cover",
                        alt: (ref4 = entity === null || entity === void 0 ? void 0 : (ref2 = entity.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.alt) !== null && ref4 !== void 0 ? ref4 : entity.title
                    }),
                    entity === null || entity === void 0 ? void 0 : (ref3 = entity.services) === null || ref3 === void 0 ? void 0 : ref3.map(function(s) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            className: "product-category",
                            children: s.title
                        }, s.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "product-content",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                        type: "h3",
                        lineClamp: 3,
                        children: entity.title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                        type: "p",
                        lineClamp: 2,
                        children: entity.abst
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                        href: (0,utils/* generateUrl */.nu)(entity, type),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                            children: t("بیشتر بخوانید", {
                                ns: "common"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var page_builder_ProductCard = (ProductCard);

;// CONCATENATED MODULE: ./src/features/page-builder/SidebarList.js




function SidebarList(param) {
    var title = param.title, items = param.items, _href = param.href, href = _href === void 0 ? "/" : _href, _linkItem = param.linkItem, linkItem = _linkItem === void 0 ? true : _linkItem, style = param.style;
    var listStyle = /*#__PURE__*/ css("display:flex;flex-direction:column;padding:1rem;.bar-body{height:300px;overflow-y:auto;}", style, ";");
    return /*#__PURE__*/ _jsxs("div", {
        css: listStyle,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                type: "h4",
                children: title
            }),
            /*#__PURE__*/ _jsx(Divider, {
                size: "2px"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "bar-body",
                children: linkItem ? items.map(function(item, idx) {
                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Link, {
                                href: href,
                                children: item.content
                            }),
                            /*#__PURE__*/ _jsx(Divider, {})
                        ]
                    }, idx);
                }) : items
            })
        ]
    });
}
/* harmony default export */ var page_builder_SidebarList = ((/* unused pure expression or super */ null && (SidebarList)));

;// CONCATENATED MODULE: ./src/features/page-builder/Checkbox.js



function Checkbox(param) {
    var label = param.label, value = param.value;
    var ref = useState(value), checked = ref[0], setChecked = ref[1];
    var handleChange = function() {
        setChecked(!checked);
    };
    var style = /*#__PURE__*/ css("cursor:pointer;.label-text{margin:0 0.5rem;}");
    return /*#__PURE__*/ _jsx(React.Fragment, {
        children: /*#__PURE__*/ _jsxs("label", {
            css: style,
            children: [
                /*#__PURE__*/ _jsx("input", {
                    type: "checkbox",
                    checked: checked,
                    onChange: handleChange
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "label-text",
                    children: label
                })
            ]
        })
    });
}
/* harmony default export */ var page_builder_Checkbox = ((/* unused pure expression or super */ null && (Checkbox)));

;// CONCATENATED MODULE: ./src/features/page-builder/ProductCarousel.js



function ProductCarousel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                ",
        "\n                &:after {\n                    content: '",
        "';\n                }\n\n            "
    ]);
    ProductCarousel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function ProductCarousel(param) {
    var _medias = param.medias, medias = _medias === void 0 ? [] : _medias;
    var ref, ref1, ref2, ref3;
    var carouselSettings = {
        rtl: true,
        loop: false,
        controls: true,
        // dots: true,
        preview: {
            sm: 1,
            md: 1,
            lg: 1,
            xl: 1,
            xxl: 1
        }
    };
    var carouselStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:10rem;height:20rem;&:after{display:block;position:absolute;left:0;bottom:1rem;padding:4px 6px;background-color:", config === null || config === void 0 ? void 0 : (ref = config.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary, ";color:", config === null || config === void 0 ? void 0 : (ref2 = config.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.white, ";border-radius:0 5px 5px 0;min-width:50%;}");
    var carouselBody = medias.map(function(m, idx) {
        var ref;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            className: "keen-slider__slide",
            css: (0,emotion_react_browser_esm/* css */.iv)(ProductCarousel_templateObject(), carouselStyle, m.title),
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                layout: "fill",
                objectFit: "cover",
                src: (m === null || m === void 0 ? void 0 : (ref = m.file) === null || ref === void 0 ? void 0 : ref.hash) && "/api/filedb/".concat(m.file.hash, ".").concat(m.file.ext),
                alt: m === null || m === void 0 ? void 0 : m.alt
            })
        }, idx);
    });
    if (medias.length > 1) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Carousel */.lr, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, carouselSettings), {
            children: carouselBody
        }))
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: carouselBody
    });
}
/* harmony default export */ var page_builder_ProductCarousel = (ProductCarousel);

// EXTERNAL MODULE: ./src/features/base-ui/Tag.jsx
var Tag = __webpack_require__(85887);
;// CONCATENATED MODULE: ./src/features/page-builder/Tag.js




function Tag_Tag(param) {
    var children = param.children, href = param.href, rounded = param.rounded, closeBtn = param.closeBtn;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var style = "\n        color: ".concat(theme.colors.white, ";\n        a {\n            color: ").concat(theme.colors.white, ";\n        }\n        border-radius: 0;\n        background-color: ").concat(theme.colors.primary, ";\n        &:hover {\n            background-color: ").concat(theme.colors.secondary, ";\n            a {\n                color: ").concat(theme.colors.white, ";\n            }\n        }\n    ");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tag/* default */.Z, {
        style: style,
        href: href,
        rounded: rounded,
        closeBtn: closeBtn,
        children: children
    });
}
/* harmony default export */ var page_builder_Tag = (Tag_Tag);

;// CONCATENATED MODULE: ./src/features/page-builder/ItemList.js



function ItemList(param) {
    var _direction = param.direction, direction = _direction === void 0 ? "horizentel" : _direction, gap = param.gap, wrap = param.wrap, title = param.title, children = param.children, style = param.style, bodyStyle = param.bodyStyle;
    var listStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;", direction === "horizental" && "flex-direction: row", ";", direction === "vertical" && "flex-direction: column", ";gap:", gap, ";", wrap && "flex-wrap: wrap", ";", style, ";");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: bodyStyle,
        children: [
            title,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "item-list",
                css: listStyle,
                children: children
            })
        ]
    });
}
/* harmony default export */ var page_builder_ItemList = (ItemList);

// EXTERNAL MODULE: ./src/features/page-builder/Button.js
var page_builder_Button = __webpack_require__(44534);
;// CONCATENATED MODULE: ./src/features/page-builder/ProductTab.js




function ProductTab(param) {
    var items = param.items;
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("width:100%;.button-group{div:first-of-type button,div:last-child button{border-radius:0;border-left:1px solid #ffffff;}}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Tab */.OK, {
            tabs: items,
            hideHeader: items.length < 2,
            children: items.map(function(item, idx) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* TabPanel */.x4, {
                        style: "width:100%;",
                        children: item.content
                    })
                }, idx);
            })
        })
    });
}
/* harmony default export */ var page_builder_ProductTab = (ProductTab);

;// CONCATENATED MODULE: ./src/features/page-builder/InfoGrid.js


// import { useTheme } from '@emotion/react'

function InfoGrid(param) {
    var _head = param.head, head = _head === void 0 ? [] : _head, _items = param.items, items = _items === void 0 ? [] : _items;
    // const theme = useTheme()
    var style = "\n        width: 100%;\n        border-radius: 0;\n        thead {\n            border-top-left-radius: 0;\n            border-top-right-radius: 0;\n        }\n        th:last-child, th:first-of-type {\n            border-top-left-radius: 0;\n            border-top-right-radius: 0;\n        }\n        th, td {\n            text-align: start;\n        }\n        td {\n            padding: 1rem;\n        }\n        th {\n            background-color: #c6dfff;\n        }\n        tr:last-child td:first-of-type, tr:last-child td:last-child, tbody {\n            border-bottom-right-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n\n    ";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Table */.iA, {
        head: head,
        style: style,
        children: items.map(function(i, idx) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                children: i.map(function(ii, idx2) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                        children: ii
                    }, idx2);
                })
            }, idx);
        })
    });
}
/* harmony default export */ var page_builder_InfoGrid = (InfoGrid);

;// CONCATENATED MODULE: ./src/features/page-builder/RelatedCarousel.js







function RelatedCarousel(param) {
    var items = param.items;
    var carouselSettings = {
        rtl: true,
        loop: false,
        controls: true,
        // dots: true,
        preview: {
            sm: 1,
            md: 2,
            lg: 3,
            xl: 3,
            xxl: 4
        }
    };
    var carouselStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("// width:10rem;// height:20rem;");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Carousel */.lr, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, carouselSettings), {
            children: items.map(function(item, idx) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    className: "keen-slider__slide",
                    css: carouselStyle,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_ProductCard, {
                        title: item.title,
                        src: item.src,
                        category: item.category
                    })
                }, idx);
            })
        }))
    });
}
/* harmony default export */ var page_builder_RelatedCarousel = (RelatedCarousel);

// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
;// CONCATENATED MODULE: ./src/features/page-builder/LinkItem.js




function LinkItem(param) {
    var children = param.children, href = param.href;
    if (!href) return null;
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0.5rem;border-bottom:1px dashed #cccccc;");
    var linkStyle = "\n        display: block;\n        width: 100%;\n        a {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            width: 100%;\n        }\n        .internal-link {\n            width: 100%;\n        }\n       \n    ";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: style,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Link */.rU, {
            href: href,
            style: linkStyle,
            children: [
                children,
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(fi_index_esm/* FiArrowUpRight */.TKU, {})
            ]
        })
    });
}
/* harmony default export */ var page_builder_LinkItem = (LinkItem);

;// CONCATENATED MODULE: ./src/features/page-builder/PostCardH.js





// import { MediaQuery } from '../base-ui/Utility'
function PostCardH(param) {
    var src = param.src, uptitle = param.uptitle, title = param.title, date = param.date, style = param.style, href = param.href;
    var cardStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;height:7rem;flex-wrap:wrap;.card-image{display:flex;justify-content:center;align-items:center;flex-basis:25%;}.content{display:flex;flex-direction:column;flex-basis:", src ? "75" : "100", "%;padding:1rem;}", style);
    // ${MediaQuery('xxl', 'min')} {
    //      padding: 1rem 1rem 1rem 0;
    // }
    var body = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: cardStyle,
        children: [
            src && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "card-image",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                    noStyle: true,
                    src: src,
                    width: 100,
                    height: 100,
                    alt: "card image",
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "content",
                children: [
                    uptitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                        type: "t",
                        lineClamp: 1,
                        children: uptitle
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                        type: "h5",
                        lineClamp: 3,
                        children: title
                    }),
                    date && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: date
                    })
                ]
            })
        ]
    });
    if (href) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
        href: href,
        children: body
    });
    return body;
}
/* harmony default export */ var page_builder_PostCardH = (PostCardH);

;// CONCATENATED MODULE: ./src/features/page-builder/BlogPost.js








function BlogPost(param) {
    var cover = param.cover, title = param.title, content = param.content, permalinl = param.permalinl, _tags = param.tags, tags = _tags === void 0 ? [] : _tags, _readMore = param.readMore, readMore = _readMore === void 0 ? [] : _readMore;
    var t = (0,esm/* useTranslation */.$G)([
        "common"
    ]).t;
    var style = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:block;padding:1rem;width:100%;height:100%;.image{position:relative;margin:1rem 0;height:200px;margin-top:2rem;}", (0,Utility/* MediaQuery */.zP)("md", "min"), "{.image{height:400px;}}");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: style,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                type: "h1",
                fontSize: "2.3rem",
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "image",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                    src: cover,
                    alt: "",
                    layout: "fill"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(webpage/* EditorTypography */.jP, {
                type: "p",
                fontWeight: "Normal",
                fontSize: "1.1rem",
                lineHeight: "2rem",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Divider */.iz, {}),
            permalinl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                        children: [
                            t("لینک کوتاه", {
                                ns: "common"
                            }),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        style: {
                            cursor: "pointer",
                            color: "blue",
                            fontSize: "0.9em"
                        },
                        onClick: function(e) {
                            navigator.clipboard.writeText(permalinl);
                            e.preventDefault();
                            return false;
                        },
                        children: permalinl
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Divider */.iz, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_ItemList, {
                title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(base_ui/* Typography */.ZT, {
                    type: "h5",
                    className: "my-4 pb-2",
                    children: [
                        t("تگ ها", {
                            ns: "common"
                        }),
                        ":"
                    ]
                }),
                gap: "0.5rem",
                children: tags.map(function(t) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_Tag, {
                        href: (0,utils/* generateUrl */.nu)(t, "tag"),
                        children: t
                    }, t);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Divider */.iz, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_ItemList, {
                direction: "vertical",
                title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                    type: "h4",
                    children: t("بیشتر بخوانید", {
                        ns: "common"
                    })
                }),
                style: "margin-bottom: 2rem;",
                children: readMore.map(function(rm, idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_LinkItem, {
                        href: (0,utils/* generateUrl */.nu)(rm, "news"),
                        children: rm.title
                    }, idx);
                })
            })
        ]
    });
}
/* harmony default export */ var page_builder_BlogPost = (BlogPost);

;// CONCATENATED MODULE: ./src/features/page-builder/OrderForm.js











function OrderForm(param) {
    var _defaultValues = param.defaultValues, defaultValues = _defaultValues === void 0 ? null : _defaultValues, _readonly = param.readonly, readonly = _readonly === void 0 ? false : _readonly;
    var ref, ref1, ref2;
    var ref3 = useState(""), message = ref3[0], setMessage = ref3[1];
    var ref4 = useState(false), success = ref4[0], setSuccess = ref4[1];
    var theme = useTheme();
    var submitting = useRef(false);
    var t = useTranslation([
        "common"
    ]).t;
    var ref5 = useForm({
        defaultValues: defaultValues
    }), register = ref5.register, errors = ref5.formState.errors, handleSubmit = ref5.handleSubmit;
    var onSubmit = function() {
        var _ref = _async_to_generator(function(data) {
            var formData, k, response, responseObject, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (submitting.current) return [
                            2
                        ];
                        submitting.current = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        formData = new FormData();
                        for(var k in data){
                            formData.append(k, data[k]);
                        }
                        return [
                            4,
                            fetch("/api/forms?id=545", {
                                method: "POST",
                                body: formData,
                                headers: {
                                    contentType: null
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        responseObject = _state.sent();
                        if (response.status === 200) {
                            setMessage("");
                            setSuccess(t("با تشکر در اسرع وقت با شما تماس میگیریم"));
                        } else if (response.status === 400) {
                            if (responseObject.newCaptchaImage) {
                            // resetField('captcha')
                            // setCaptchaImage(responseObject.newCaptchaImage)
                            }
                            setMessage(responseObject.message);
                        }
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("An unexpected error happened occurred:", error);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        submitting.current = false;
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var style = /*#__PURE__*/ css("border-radius:0;margin:2rem auto 0 auto;max-width:64rem;form{display:flex;justify-content:center;gap:2rem 1rem;width:100%;flex-wrap:wrap;.form-input input{height:45px;width:100%;padding:0.25rem 0.5rem;background-color:#ededed;border-bottom:2px solid ", theme.colors.primary, ";line-height:2rem;outline:none;&:focus{background-color:#f3f3f3;}}.form-input input::placeholder{font-size:0.9rem;}label{font-size:0.9rem;color:", theme.colors.medGray, ";display:block;margin-bottom:0.25rem;}.submit{flex-basis:100%;margin:20px 40%;padding:0.5rem;display:flex;justify-content:center;}.error{font-size:0.85rem;color:", theme.colors.danger, ";}.required label{&:after{content:'*';color:red;}}", MediaQuery("lg", "max"), "{.form-input{flex-basis:99%;}}", MediaQuery("lg", "min"), "{.form-input{flex-basis:44%;}}}");
    return /*#__PURE__*/ _jsxs(Card, {
        css: style,
        bordered: true,
        children: [
            success && /*#__PURE__*/ _jsx("div", {
                style: {
                    fontSize: 26,
                    color: "green",
                    width: "100%",
                    textAlign: "center"
                },
                children: success
            }),
            !success && /*#__PURE__*/ _jsxs("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "form-input required",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                children: "نام"
                            }),
                            /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({}, register("firstName", {
                                required: true,
                                disabled: readonly
                            })), {
                                "aria-invalid": errors.firstName ? "true" : "false"
                            })),
                            ((ref = errors.firstName) === null || ref === void 0 ? void 0 : ref.type) === "required" && /*#__PURE__*/ _jsx("p", {
                                className: "error",
                                role: "alert",
                                children: t("این فیلد ضروری است")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "form-input required",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                children: "نام خانوادگی"
                            }),
                            /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({}, register("lastName", {
                                required: true,
                                disabled: readonly
                            })), {
                                "aria-invalid": errors.lastName ? "true" : "false"
                            })),
                            ((ref1 = errors.lastName) === null || ref1 === void 0 ? void 0 : ref1.type) === "required" && /*#__PURE__*/ _jsx("p", {
                                className: "error",
                                role: "alert",
                                children: t("این فیلد ضروری است")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "form-input required",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                children: "موبایل"
                            }),
                            /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({}, register("tel", {
                                required: true,
                                // maxLength: 11,
                                disabled: readonly
                            })), {
                                type: "number",
                                "aria-invalid": errors.tel ? "true" : "false"
                            })),
                            ((ref2 = errors.tel) === null || ref2 === void 0 ? void 0 : ref2.type) === "required" && /*#__PURE__*/ _jsx("p", {
                                className: "error",
                                role: "alert",
                                children: t("این فیلد ضروری است")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "form-input",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                children: "ایمیل"
                            }),
                            /*#__PURE__*/ _jsx("input", _object_spread({}, register("mail", {
                                required: false,
                                disabled: readonly
                            })))
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "form-input",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                children: "کشور"
                            }),
                            /*#__PURE__*/ _jsx("input", _object_spread({}, register("country", {
                                required: false,
                                disabled: readonly
                            })))
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "form-input",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                children: "شهر"
                            }),
                            /*#__PURE__*/ _jsx("input", _object_spread({}, register("city", {
                                required: false,
                                disabled: readonly
                            })))
                        ]
                    }),
                    !readonly && /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        backgroundColor: "primary",
                        color: "white",
                        children: "ارسال"
                    })
                ]
            }),
            message && /*#__PURE__*/ _jsx("div", {
                style: {
                    fontSize: 20,
                    color: "red",
                    width: "100%",
                    marginBottom: 10
                },
                children: message
            })
        ]
    });
}
/* harmony default export */ var page_builder_OrderForm = ((/* unused pure expression or super */ null && (OrderForm)));

;// CONCATENATED MODULE: ./src/features/page-builder/LinkBox.js





function LinkBox(param) {
    var items = param.items, _transparent = param.transparent, transparent = _transparent === void 0 ? false : _transparent;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:1rem;", !transparent && "background-color: #fff;", "                margin-top:1rem;", !transparent && "border: 1px solid #ddd;"),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder_ItemList, {
            direction: "horizentel",
            gap: "0.5rem",
            wrap: true,
            children: items.map(function(item, idx) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Tag */.Vp, {
                    href: item.href,
                    nofollow: item.nofollow,
                    target: "_blank",
                    children: item.title
                }, idx);
            })
        })
    });
}
/* harmony default export */ var page_builder_LinkBox = (LinkBox);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/features/page-builder/AdScriptUrl.js







function AdScriptUrl(_param) {
    var url = _param.url, _directUrl = _param.directUrl, directUrl = _directUrl === void 0 ? false : _directUrl, id = _param.id, others = (0,_object_without_properties/* default */.Z)(_param, [
        "url",
        "directUrl",
        "id"
    ]);
    var ref;
    var data = (0,dataProvider/* useDataProvider */.x5)().data;
    if (!(data === null || data === void 0 ? void 0 : data.buildTime)) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            url && Array.isArray(url) && url.map(function(url, idx) {
                var ref;
                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    id: "".concat(id, "-").concat(idx),
                    src: !directUrl ? "".concat(url).concat(data === null || data === void 0 ? void 0 : (ref = data.buildTime) === null || ref === void 0 ? void 0 : ref.replace(/[-.T:Z]/g, "")) : url
                }, others), {
                    async: true
                }), idx);
            }),
            url && !Array.isArray(url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                id: id,
                src: !directUrl ? "".concat(url).concat(data === null || data === void 0 ? void 0 : (ref = data.buildTime) === null || ref === void 0 ? void 0 : ref.replace(/[-.T:Z]/g, "")) : url
            }, others), {
                async: true
            }))
        ]
    });
}
/* harmony default export */ var page_builder_AdScriptUrl = (AdScriptUrl);

;// CONCATENATED MODULE: ./src/features/page-builder/index.js

































/***/ }),

/***/ 56857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _config_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51181);
/* harmony import */ var _hooks_dataProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46766);







function Head(param) {
    var trackUrl = param.trackUrl;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var data = (0,_hooks_dataProvider__WEBPACK_IMPORTED_MODULE_3__/* .useDataProvider */ .x5)().data;
    if (true) {
        var ref10, ref11, ref12;
        if (_config_json__WEBPACK_IMPORTED_MODULE_2__ === null || _config_json__WEBPACK_IMPORTED_MODULE_2__ === void 0 ? void 0 : (ref10 = _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.sanjagh) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.push) === null || ref12 === void 0 ? void 0 : ref12.token) window.snj_notif = {
            publisher_id: _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.sanjagh.push.token,
            delay: 5
        };
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("link", {
                        rel: "shortcut icon",
                        type: "image/x-icon",
                        href: "/img/favicon/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/img/favicon/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/img/favicon/apple-touch-icon.png"
                    })
                ]
            }),
            ((ref = _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations) === null || ref === void 0 ? void 0 : ref.umami) && trackUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "umami-tracker",
                async: true,
                defer: true,
                "data-auto-track": "false",
                "data-website-id": _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.umami.websiteId,
                src: "".concat(_config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.umami.endpoint, "/script.js"),
                onLoad: function() {
                    /* global umami */ umami.track(function(props) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
                            url: trackUrl
                        });
                    });
                }
            }),
            ((ref1 = _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations) === null || ref1 === void 0 ? void 0 : ref1.truepush) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                type: "application/javascript",
                src: _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.truepush.sdk,
                async: true
            }),
            ((ref2 = _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations) === null || ref2 === void 0 ? void 0 : ref2.promizer) && (data === null || data === void 0 ? void 0 : data.buildTime) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                        id: "promizer-loader",
                        type: "application/javascript",
                        src: "https://cdn-my.promizer.com/api/public/_/".concat(data.buildTime.split("T")[0].replace(/-/g, ""), "/sdk/script.js"),
                        async: true
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                        id: "promizer-config",
                        dangerouslySetInnerHTML: {
                            __html: 'window.promizer = window.promizer || {\n                                push: "'.concat(_config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.promizer.push, '",\n                                config: ').concat(JSON.stringify(_config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.promizer.config), "\n                              };")
                        }
                    })
                ]
            }),
            ((ref3 = _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations) === null || ref3 === void 0 ? void 0 : ref3.truepush) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "truepush",
                dangerouslySetInnerHTML: {
                    __html: "var truepush = window.truepush || []; truepush.push(function()\n                {truepush.Init(\n                    {\n                        id: '".concat(_config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.truepush.token, "'\n                    },\n                    function (error) {\n                        if (error) console.error(error)\n                    }\n                )}\n                )")
                }
            }),
            ((ref4 = _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.sanjagh) === null || ref5 === void 0 ? void 0 : ref5.push) && (data === null || data === void 0 ? void 0 : data.buildTime) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                    type: "application/javascript",
                    src: "https://cdn.sanjagh.com/assets/sdk/notif.js?t=".concat(data.buildTime),
                    async: false
                })
            }),
            ((ref6 = _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations) === null || ref6 === void 0 ? void 0 : ref6.ua) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(_config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.ua.id)
            }),
            ((ref7 = _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations) === null || ref7 === void 0 ? void 0 : ref7.ua) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "googleTag",
                dangerouslySetInnerHTML: {
                    __html: "window.dataLayer = window.dataLayer || [];\n                            function gtag(){dataLayer.push(arguments);}\n                            gtag('js', new Date());\n                            gtag('config', '".concat(_config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.ua.id, "');")
                }
            }),
            ((ref8 = _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations) === null || ref8 === void 0 ? void 0 : ref8.ga) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                async: true,
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(_config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.ga.id)
            }),
            ((ref9 = _config_json__WEBPACK_IMPORTED_MODULE_2__.integrations) === null || ref9 === void 0 ? void 0 : ref9.ga) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "googleTagOld",
                dangerouslySetInnerHTML: {
                    __html: " window.dataLayer = window.dataLayer || [];\n                            function gtag(){dataLayer.push(arguments);}\n                            gtag('js', new Date());\n                            gtag('config', '".concat(_config_json__WEBPACK_IMPORTED_MODULE_2__.integrations.ga.id, "');")
                }
            })
        ]
    });
}


/***/ }),

/***/ 32238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20442);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60155);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5434);
/* harmony import */ var _base_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82843);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74614);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                                                    display: flex;\n                                                    flex-direction: column;\n                                                "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n                                            outline-color: ",
        ";\n                                        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            position: absolute;\n            display: flex;\n            margin-left: auto;\n            margin-right: auto;\n            top: 0;\n            left: 0;\n            right: 0;\n            z-index: 9;\n            .card {\n                border-radius: 0.5rem;\n                border-top-right-radius: 0;\n                border-top-left-radius: 0;\n            }\n            .card-body {\n                padding: 1rem;\n            }\n            .card-content {\n                display: flex;\n                flex-direction: column;\n                gap: 0.5rem;\n            }\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








function Nav(param) {
    var items = param.items, _type = param.type, type = _type === void 0 ? "default" : _type, onClose = param.onClose, _visible = param.visible, visible = _visible === void 0 ? false : _visible;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__.u)();
    var openRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({});
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var menuItemStyle = "\n        font-size: 1rem;\n        font-weight: 500;\n    ";
    var subMenuStyle = "\n        border-bottom: 2px solid ".concat(theme.colors.secondary, ";\n        padding: 0.25rem 0;\n        width: fit-content;\n        margin: 0.25rem 0;\n        a {\n            color: ").concat(theme.colors.white, ";\n            &:active {\n                background-color: ").concat(theme.colors.primary, ";\n                color: ").concat(theme.colors.white, ";            \n            }\n        }\n    ");
    var navColor = theme.colors.nav.color;
    var navHoverColor = theme.colors.nav.hover;
    var defaultNav = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("ul", {
        className: "hidden lg:flex flex-wrap mb-0 items-center",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("li", {
                className: "mx-3",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                        href: "/",
                        hoverColor: navHoverColor,
                        color: navColor,
                        style: menuItemStyle,
                        children: t("خانه")
                    })
                })
            }),
            items === null || items === void 0 ? void 0 : items.map(function(s, idx) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(NavItem, {
                    navColor: navColor,
                    navHoverColor: navHoverColor,
                    link: s.link,
                    label: s.label,
                    items: s.children,
                    depth: s.maxDepth,
                    openRef: openRef
                }, idx);
            })
        ]
    });
    var mobileNav = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        className: "lg:hidden fixed w-screen h-screen -top-0 bg-gray-600 bg-opacity-20 z-20 backdrop-filter backdrop-blur-sm ".concat(visible ? "block" : "hidden"),
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("right:0;"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
            className: "mobile-nav slideMenu w-52 bg-white float-left px-6 h-full overflow-y-auto \n            ".concat(visible ? "slideEnter" : "hidden"),
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("button", {
                    className: "mt-12 flex items-center gap-2 close-btn",
                    css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)("color:", navColor, ";"),
                    onClick: onClose,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoClose */ .bjh, {
                            className: "text-2xl"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
                            className: "text-md",
                            children: t("بستن")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("ul", {
                    className: "pt-6",
                    children: items === null || items === void 0 ? void 0 : items.map(function(s, idx) {
                        var ref;
                        if ((ref = s.children) === null || ref === void 0 ? void 0 : ref.length) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("li", {
                            className: "mb-6",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .Accordion */ .UQ, {
                                title: s.label,
                                content: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("div", {
                                    css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject()),
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                                            href: s.link,
                                            onClick: onClose,
                                            style: subMenuStyle,
                                            color: navColor,
                                            children: s.label
                                        }, idx),
                                        s.children.map(function(item, idx) {
                                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                                                href: item.link,
                                                onClick: onClose,
                                                style: subMenuStyle,
                                                color: navColor,
                                                children: item.label
                                            }, idx);
                                        })
                                    ]
                                })
                            }, idx)
                        }, idx);
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("li", {
                            className: "mb-6",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                                href: s.link,
                                onClick: onClose,
                                style: "display: block; width: 100%",
                                color: navColor,
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
                                    className: "block outline outline-offset-4 outline-1 text-start rounded px-2 py-1 w-full bg-gray-100",
                                    css: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject1(), navColor),
                                    children: s.label
                                })
                            })
                        }, idx);
                    })
                })
            ]
        })
    });
    if (type === "default") return defaultNav;
    return mobileNav;
}
/* harmony default export */ __webpack_exports__["Z"] = (Nav);
function NavItem(param) {
    var navColor = param.navColor, navHoverColor = param.navHoverColor, link = param.link, label = param.label, items = param.items, openRef = param.openRef, depth = param.depth;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isHovering = ref[0], setIsHovering = ref[1];
    var elRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var handleMouseOver = function() {
        var ref;
        if ((openRef === null || openRef === void 0 ? void 0 : (ref = openRef.current) === null || ref === void 0 ? void 0 : ref.setIsHovering) && openRef.current.setIsHovering !== setIsHovering) openRef.current.setIsHovering(false);
        setIsHovering(true);
        if (openRef) openRef.current.setIsHovering = setIsHovering;
    };
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("menu");
    var outsideClickAlert = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setIsHovering(false);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(event) {
            var ref;
            if (((ref = wrapperRef.current) === null || ref === void 0 ? void 0 : ref.contains) && !wrapperRef.current.contains(event.target)) {
                outsideClickAlert();
            }
        };
        // Bind
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            // dispose
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        wrapperRef,
        outsideClickAlert
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)("li", {
        className: "mx-3",
        ref: elRef,
        children: [
            !!(items === null || items === void 0 ? void 0 : items.length) && // <span
            //     style={{ color: navColor, cursor: 'default' }}
            //     onMouseOver={handleMouseOver}
            // >
            //     <MdArrowDropDown className="inline-block" /> {label}
            // </span>
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                href: link,
                color: navColor,
                hoverColor: navHoverColor,
                onMouseOver: handleMouseOver,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdArrowDropDown */ .gwH, {
                        className: "inline-block"
                    }),
                    " ",
                    label
                ]
            }),
            !(items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                href: link,
                color: navColor,
                hoverColor: navHoverColor,
                onMouseOver: handleMouseOver,
                children: [
                    Boolean(items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdArrowDropDown */ .gwH, {
                        className: "inline-block"
                    }),
                    " ",
                    label
                ]
            }),
            Boolean(items === null || items === void 0 ? void 0 : items.length) && depth === 1 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(WatefallMenu, {
                    style: {
                        // left: elRef.current?.offsetLeft ?? 0,
                        width: "max-content"
                    },
                    ref: wrapperRef,
                    visible: isHovering,
                    items: items,
                    onFocus: function() {
                        setIsHovering(true);
                    },
                    onBlur: function() {
                        setIsHovering(false);
                    }
                })
            }),
            Boolean(items === null || items === void 0 ? void 0 : items.length) && depth > 1 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .MegaMenu */ .Vn, {
                ref: wrapperRef,
                visible: isHovering,
                onFocus: function() {
                    setIsHovering(true);
                },
                onBlur: function() {
                // setIsHovering(false)
                },
                menuData: items
            })
        ]
    });
}
var WatefallMenu = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var items = param.items, _visible = param.visible, visible = _visible === void 0 ? false : _visible, onBlur = param.onBlur, onFocus = param.onFocus, style = param.style;
    var csss = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject2());
    if (!visible) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", {
        style: style,
        ref: ref,
        className: "container waterfall-menu",
        css: csss,
        onMouseOver: onFocus,
        onMouseOut: onBlur,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Zb, {
            bordered: true,
            shadow: "md",
            style: "height: 100%;",
            children: items.map(function(item, idx) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_base_ui__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    href: item.link,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("span", {
                        className: "mx-2",
                        children: item.label
                    })
                }, idx);
            })
        })
    });
});


/***/ }),

/***/ 89248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WebsiteFooter; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/hooks/dataProvider/index.js + 1 modules
var dataProvider = __webpack_require__(46766);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js + 1 modules
var emotion_element_f0de968e_browser_esm = __webpack_require__(20442);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./src/features/page-builder/index.js + 28 modules
var page_builder = __webpack_require__(57412);
// EXTERNAL MODULE: ./config.json
var config = __webpack_require__(51181);
;// CONCATENATED MODULE: ./src/features/webpage/ThemeFooter.js






function ThemeFooter(param) {
    var style = param.style, _socialIcons = param.socialIcons, socialIcons = _socialIcons === void 0 ? [] : _socialIcons;
    var ref, ref1, ref2;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var footerColor = theme.colors.websiteFooter.color;
    var footerHoverColor = theme.colors.websiteFooter.hover;
    var footerBackground = theme.colors.websiteFooter.backgroundColor;
    var ref3;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("footer", {
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border-top:1px solid rgba(0,0,0,0.08);background:url('/img/project/footer.png'),", footerBackground, ";background-size:cover;background-position:bottom;background-repeat:no-repeat;color:", footerColor, ";.typography,.link a{color:", footerColor, ";}.link a{&:hover{color:", footerHoverColor, ";}}", style),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder/* FooterAbout */.FZ, {
            about: (ref = config.texts) === null || ref === void 0 ? void 0 : ref.footer_about,
            src: "/img/project/logo-light.png",
            style: "text-align: center; max-width: 40rem; margin: 0 auto; .typography {text-align: center !important;}",
            social: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(page_builder/* SocialLinks */.WG, {
                socials: (0,_to_consumable_array/* default */.Z)(socialIcons).concat((0,_to_consumable_array/* default */.Z)((ref3 = config === null || config === void 0 ? void 0 : (ref1 = config.texts) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.social) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref3 !== void 0 ? ref3 : []), [
                    {
                        name: "rss",
                        href: "/feeds"
                    }, 
                ]),
                style: "justify-content: center;"
            })
        })
    });
}
/* harmony default export */ var webpage_ThemeFooter = (ThemeFooter);

;// CONCATENATED MODULE: ./src/features/webpage/WebsiteFooter.js



function WebsiteFooter() {
    var data = (0,dataProvider/* useDataProvider */.x5)().data;
    if ((data === null || data === void 0 ? void 0 : data.showFooter) === false) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(webpage_ThemeFooter, {});
}


/***/ }),

/***/ 21648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jP": function() { return /* reexport */ webpage_EditorTypography; },
  "Fb": function() { return /* reexport */ Head/* default */.Z; },
  "iS": function() { return /* reexport */ webpage_LatestPosts; },
  "PT": function() { return /* reexport */ webpage_LatestPostsFilter; },
  "JL": function() { return /* reexport */ Nav/* default */.Z; },
  "eu": function() { return /* reexport */ NewsCard; },
  "$L": function() { return /* reexport */ Widget; },
  "Yj": function() { return /* reexport */ webpage_WidgetList; }
});

// UNUSED EXPORTS: IconTitle, ImageCard, InlineNewsAd, PageHeader, WebsiteFooter

// EXTERNAL MODULE: ./src/features/webpage/WebsiteFooter.js + 1 modules
var WebsiteFooter = __webpack_require__(89248);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/features/webpage/PageHeader.jsx




function PageHeader(param) {
    var img_path = param.img_path, title = param.title, breadcrumb = param.breadcrumb, className = param.className;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: className,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("background-image:url(", img_path, ");background-repeat:no-repeat;background-size:cover;background-position:center center;display:flex;flex-direction:column;justify-content:center;align-items:center;height:40vh;overflow:hidden;padding-bottom:20px;"),
        children: [
            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                className: "text-4xl ".concat(breadcrumb && ""),
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:#fff;margin-top:12px;"),
                children: title
            }),
            breadcrumb && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "text-white px-3 py-2 mt-0 relative top-12",
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("color:#fff;background-color:rgba(255,255,255,0.4);"),
                children: Array.isArray(breadcrumb) ? breadcrumb.join(" > ") : breadcrumb + ""
            })
        ]
    });
}
PageHeader.propTypes = {
    img_path: (prop_types_default()).string,
    title: (prop_types_default()).string,
    breadcrumb: prop_types_default().oneOfType([
        (prop_types_default()).string,
        prop_types_default().arrayOf((prop_types_default()).string)
    ])
};
/* harmony default export */ var webpage_PageHeader = ((/* unused pure expression or super */ null && (PageHeader)));

// EXTERNAL MODULE: ./src/features/webpage/Head.js
var Head = __webpack_require__(56857);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js + 1 modules
var emotion_element_f0de968e_browser_esm = __webpack_require__(20442);
// EXTERNAL MODULE: ./src/hooks/useBreakpoints.js
var useBreakpoints = __webpack_require__(22807);
// EXTERNAL MODULE: ./src/utils/index.js + 3 modules
var utils = __webpack_require__(12311);
// EXTERNAL MODULE: ./src/features/base-ui/index.js + 31 modules
var base_ui = __webpack_require__(82843);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./config.json
var config = __webpack_require__(51181);
// EXTERNAL MODULE: ./src/utils/news.js
var utils_news = __webpack_require__(98993);
;// CONCATENATED MODULE: ./src/features/webpage/NewsCard.jsx












function NewsCard(_param) {
    var news = _param.news, showAbst = _param.showAbst, shadow = _param.shadow, _type = _param.type, type = _type === void 0 ? "default" : _type, imageWidth = _param.imageWidth, imageHeight = _param.imageHeight, _borderStyle = _param.borderStyle, borderStyle = _borderStyle === void 0 ? "rounded" : _borderStyle, _cardImage = _param.cardImage, cardImage = _cardImage === void 0 ? true : _cardImage, spacing = _param.spacing, imageAlt = _param.imageAlt, _horizentalImageSize = _param.horizentalImageSize, horizentalImageSize = _horizentalImageSize === void 0 ? "normal" : _horizentalImageSize, _titleHtmlEl = _param.titleHtmlEl, titleHtmlEl = _titleHtmlEl === void 0 ? "h6" : _titleHtmlEl, _titleColor = _param.titleColor, titleColor = _titleColor === void 0 ? null : _titleColor, _uptitleLines = _param.uptitleLines, uptitleLines = _uptitleLines === void 0 ? 1 : _uptitleLines, _titleLines = _param.titleLines, titleLines = _titleLines === void 0 ? 2 : _titleLines, _uptitleHtmlEl = _param.uptitleHtmlEl, uptitleHtmlEl = _uptitleHtmlEl === void 0 ? "t" : _uptitleHtmlEl, _uptitleColor = _param.uptitleColor, uptitleColor = _uptitleColor === void 0 ? "medGray" : _uptitleColor, uptitleStyle = _param.uptitleStyle, _contentLines = _param.contentLines, contentLines = _contentLines === void 0 ? 2 : _contentLines, titleFontSize = _param.titleFontSize, contentStyle = _param.contentStyle, className = _param.className, style = _param.style, align = _param.align, target = _param.target, _footer = _param.footer, footer = _footer === void 0 ? true : _footer, others = (0,_object_without_properties/* default */.Z)(_param, [
        "news",
        "showAbst",
        "shadow",
        "type",
        "imageWidth",
        "imageHeight",
        "borderStyle",
        "cardImage",
        "spacing",
        "imageAlt",
        "horizentalImageSize",
        "titleHtmlEl",
        "titleColor",
        "uptitleLines",
        "titleLines",
        "uptitleHtmlEl",
        "uptitleColor",
        "uptitleStyle",
        "contentLines",
        "titleFontSize",
        "contentStyle",
        "className",
        "style",
        "align",
        "target",
        "footer"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var breakpoint = (0,useBreakpoints/* default */.Z)();
    var mobileScreen = breakpoint.xs || breakpoint.sm;
    var responsiveTitleLines = mobileScreen ? 5 : 3;
    var horizentalUptitleLines = mobileScreen ? 2 : 1;
    var horizentalSpacing = mobileScreen ? "sm" : "md";
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
        rel: (news === null || news === void 0 ? void 0 : news.forward_link) ? "nofollow" : "",
        target: target,
        href: (0,utils/* generateUrl */.nu)(news, "news", {
            asLinkStyle: true
        }),
        nextHrefAs: (0,utils/* generateUrl */.nu)(news, "news"),
        nextPrefetch: true,
        style: "\n                    display: block;\n                    &:hover {\n                        .typography {\n                            color: ".concat(theme.colors.primary, ";\n                        }\n                    }\n                    ").concat(style, "\n                "),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Card */.Zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            align: align,
            shadow: shadow,
            imgWidth: imageWidth,
            borderStyle: borderStyle,
            imgHeight: type === "default" ? imageHeight : imageWidth,
            imgAlt: imageAlt || (news === null || news === void 0 ? void 0 : news.title),
            className: className,
            type: type,
            spacing: type === "default" ? spacing : horizentalSpacing,
            imgSrc: cardImage && (news === null || news === void 0 ? void 0 : (ref = news.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.hash) && (news === null || news === void 0 ? void 0 : (ref2 = news.thumbnail) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.file) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.mime) === null || ref4 === void 0 ? void 0 : ref4.indexOf("image/")) === 0 && "/api/filedb/".concat(news.thumbnail.file.hash, ".").concat(news.thumbnail.file.ext),
            videoSrc: cardImage && (news === null || news === void 0 ? void 0 : (ref5 = news.thumbnail) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.file) === null || ref6 === void 0 ? void 0 : ref6.hash) && (news === null || news === void 0 ? void 0 : (ref7 = news.thumbnail) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.file) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.mime) === null || ref9 === void 0 ? void 0 : ref9.indexOf("video/")) === 0 && "/api/filedb/".concat(news.thumbnail.file.hash, ".").concat(news.thumbnail.file.ext),
            horizentalImageSize: horizentalImageSize,
            style: type === "horizental" && "min-height: 9rem;",
            subtitle: uptitleLines > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                type: uptitleHtmlEl,
                color: uptitleColor,
                lineClamp: type === "default" ? uptitleLines : horizentalUptitleLines,
                style: uptitleStyle,
                children: news === null || news === void 0 ? void 0 : news.uptitle
            }),
            title: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                type: titleHtmlEl || "h5",
                color: titleColor,
                fontWeight: "Bold",
                fontSize: titleFontSize,
                lineClamp: titleLines || responsiveTitleLines,
                children: news === null || news === void 0 ? void 0 : news.title
            }),
            footer: footer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                        style: {
                            paddingBottom: type === "default" ? 4 : "unset",
                            unicodeBidi: "plaintext"
                        },
                        children: [
                            ((ref10 = config.settings) === null || ref10 === void 0 ? void 0 : ref10.use_time_in_news_cards) && (0,utils_news/* newsDisplayedPubDate */.iu)(news),
                            !((ref11 = config.settings) === null || ref11 === void 0 ? void 0 : ref11.use_time_in_news_cards) && (0,utils/* distanceFromNow */.zM)((0,utils_news/* newsDisplayedPubDate */.iu)(news, "date"), {
                                locale: locale
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "mr-auto",
                        dir: "ltr",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* ShareButton */.Tz, {
                            title: news === null || news === void 0 ? void 0 : news.title,
                            url: (0,utils/* generateUrl */.nu)(news, "news", {
                                absolute: true
                            })
                        })
                    })
                ]
            })
        }, others), {
            children: showAbst && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                type: "p",
                style: contentStyle,
                color: "medGray",
                lineClamp: contentLines,
                children: news === null || news === void 0 ? void 0 : news.abst
            })
        }))
    });
}

;// CONCATENATED MODULE: ./src/features/webpage/WidgetList.jsx






function WidgetList(param) {
    var widget = param.widget, _filterItem = param.filterItem, filterItem = _filterItem === void 0 ? function(param) {
        var news = param.news;
        return news;
    } : _filterItem, itemRender = param.itemRender, divider = param.divider, _columns = param.columns, columns = _columns === void 0 ? 1 : _columns, showItem = param.showItem, className = param.className, _orientation = param.orientation, orientation = _orientation === void 0 ? "default" : _orientation, _gap = param.gap, gap = _gap === void 0 ? "1px" : _gap, title = param.title, _titleSetting = param.titleSetting, titleSetting = _titleSetting === void 0 ? {} : _titleSetting, _noStyle = param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, listStyle = param.listStyle;
    var ref, ref1, ref2;
    if (!showItem) showItem = widget === null || widget === void 0 ? void 0 : widget.limit;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var data = (widget === null || widget === void 0 ? void 0 : widget.newsList) || widget;
    var newsListSortFn = function(a, b) {
        return a.position - b.position;
    };
    var ref3, ref4;
    var myData = filterItem ? (ref3 = (ref1 = (ref = data === null || data === void 0 ? void 0 : data.sort(newsListSortFn)) === null || ref === void 0 ? void 0 : ref.filter(filterItem)) === null || ref1 === void 0 ? void 0 : ref1.slice(0, showItem)) !== null && ref3 !== void 0 ? ref3 : [] : (ref4 = (ref2 = data === null || data === void 0 ? void 0 : data.sort(newsListSortFn)) === null || ref2 === void 0 ? void 0 : ref2.slice(0, showItem)) !== null && ref4 !== void 0 ? ref4 : [];
    divider = divider || /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        style: {
            margin: gap
        }
    });
    if (noStyle) return myData.map(function(item, idx) {
        return /*#__PURE__*/ react.createElement(itemRender, {
            post: item,
            idx: idx,
            key: idx
        });
    });
    var horizentalList = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: className,
        children: [
            title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* SectionTitle */.NZ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, titleSetting), {
                children: title
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "content",
                css: noStyle ? null : /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:grid;grid-template-columns:repeat(", columns, ",minmax(0,1fr));gap:", gap, ";border-radius:", theme.borderRadius.default, ";.card-content{display:flex;flex-direction:column;}"),
                style: listStyle,
                children: myData.map(function(item, idx) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ react.createElement(itemRender, {
                                post: item,
                                idx: idx
                            }),
                            idx < myData.length - 1 && divider
                        ]
                    }, idx);
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: orientation === "default" && horizentalList
    });
}
/* harmony default export */ var webpage_WidgetList = (WidgetList);

;// CONCATENATED MODULE: ./src/features/webpage/EditorTypography.jsx







function EditorTypography(_param) {
    var type = _param.type, children = _param.children, allProbs = (0,_object_without_properties/* default */.Z)(_param, [
        "type",
        "children"
    ]);
    var breakpoint = (0,useBreakpoints/* default */.Z)();
    var miniScreen = breakpoint.xs || breakpoint.sm || breakpoint.md;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var style = "\n        a {\n            color : ".concat(theme.colors.secondaryLight, ";\n        }\n        img {\n            width: auto !important;\n            height: auto !important;\n            object-fit: contain;\n        }\n        table {\n            width: auto !important;\n            height: auto !important;\n        }\n        ").concat(miniScreen && "img {\n                max-width: 100% !important;\n            }\n            table {\n                width: 100% !important;\n            }", "\n    ");
    var typoSwitch = function(hType) {
        switch(hType){
            case "h1":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h1.fontSize,
                    lineHeight: theme.typography.h1.lineHeight,
                    fontWeight: theme.typography.h1.fontWeight,
                    style: style
                }, allProbs), {
                    children: children
                }));
            case "h2":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h2.fontSize,
                    lineHeight: theme.typography.h2.lineHeight,
                    fontWeight: theme.typography.h2.fontWeight,
                    style: style
                }, allProbs), {
                    children: children
                }));
            case "h3":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h3.fontSize,
                    lineHeight: theme.typography.h3.lineHeight,
                    fontWeight: theme.typography.h3.fontWeight,
                    style: style
                }, allProbs), {
                    children: children
                }));
            case "h4":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h4.fontSize,
                    lineHeight: theme.typography.h4.lineHeight,
                    fontWeight: theme.typography.h4.fontWeight,
                    style: style
                }, allProbs), {
                    children: children
                }));
            case "h5":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h5.fontSize,
                    lineHeight: theme.typography.h5.lineHeight,
                    fontWeight: theme.typography.h5.fontWeight,
                    style: style
                }, allProbs), {
                    children: children
                }));
            case "h6":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.h6.fontSize,
                    lineHeight: theme.typography.h6.lineHeight,
                    fontWeight: theme.typography.h6.fontWeight,
                    style: style
                }, allProbs), {
                    children: children
                }));
            case "p":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.p.fontSize,
                    lineHeight: theme.typography.p.lineHeight,
                    fontWeight: theme.typography.p.fontWeight,
                    style: style
                }, allProbs), {
                    children: children
                }));
            case "t":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.t.fontSize,
                    lineHeight: theme.typography.t.lineHeight,
                    fontWeight: theme.typography.t.fontWeight,
                    style: style
                }, allProbs), {
                    children: children
                }));
            case "div":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "dynamic-content ",
                    type: "div",
                    fontSize: theme.typography.div.fontSize,
                    lineHeight: theme.typography.div.lineHeight,
                    fontWeight: theme.typography.div.fontWeight,
                    style: style
                }, allProbs), {
                    children: children
                }));
        }
    };
    return typoSwitch(type);
}
/* harmony default export */ var webpage_EditorTypography = (EditorTypography);

// EXTERNAL MODULE: ./src/features/webpage/Nav.jsx
var Nav = __webpack_require__(32238);
;// CONCATENATED MODULE: ./src/features/webpage/LatestPosts.jsx





function LatestPosts(param) {
    var widgetName = param.widgetName, title = param.title, _titleLines = param.titleLines, titleLines = _titleLines === void 0 ? 2 : _titleLines, _showUptitle = param.showUptitle, showUptitle = _showUptitle === void 0 ? true : _showUptitle;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(webpage_WidgetList, {
        widget: widgetName,
        title: title,
        css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".content{background-color:#fff;}.card-title{margin-bottom:0 !important;}.link{height:7.5rem;}"),
        divider: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Divider */.iz, {
            gap: "5px"
        }),
        filterItem: false,
        itemRender: function(param) {
            var post = param.post;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsCard, {
                type: "horizental",
                titleLines: titleLines,
                cardImage: false,
                titleHtmlEl: "h6",
                uptitleLines: showUptitle,
                titleFontSize: "0.95rem",
                horizentalImageSize: "narrow",
                contentStyle: {
                    fontSize: "0.9rem"
                },
                news: post
            });
        }
    });
}
/* harmony default export */ var webpage_LatestPosts = (LatestPosts);

;// CONCATENATED MODULE: ./src/features/webpage/Widget.jsx


function Widget(param) {
    var data = param.data, className = param.className, _listProperty = param.listProperty, listProperty = _listProperty === void 0 ? "newsList" : _listProperty, children = param.children;
    var items = (0,react.useMemo)(function() {
        var ref, ref1;
        var ref2, ref3;
        return (ref3 = (ref1 = data === null || data === void 0 ? void 0 : (ref = data[listProperty]) === null || ref === void 0 ? void 0 : ref.sort(function(a, b) {
            return a.position - b.position;
        })) === null || ref1 === void 0 ? void 0 : ref1.slice(0, (ref2 = data === null || data === void 0 ? void 0 : data.limit) !== null && ref2 !== void 0 ? ref2 : 1)) !== null && ref3 !== void 0 ? ref3 : [];
    }, [
        data,
        listProperty
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        className: className,
        children: children({
            list: items,
            title: data === null || data === void 0 ? void 0 : data.title
        })
    });
}

;// CONCATENATED MODULE: ./src/features/webpage/ImageCard.js




function ImageCard(param) {
    var cardImage = param.cardImage, _cardColor = param.cardColor, cardColor = _cardColor === void 0 ? "transparent" : _cardColor, title = param.title, _aspectRatio = param.aspectRatio, aspectRatio = _aspectRatio === void 0 ? "6 / 4" : _aspectRatio, href = param.href;
    var theme = useTheme();
    var inner = /*#__PURE__*/ _jsx("div", {
        css: /*#__PURE__*/ css("position:relative;background:url('", cardImage, "'),", cardColor, ";background-size:cover;background-repeat:no-repeat;background-position:center;border-radius:", theme.borderRadius.default, ";box-shadow:", theme.boxShadow.default, ";aspect-ratio:", aspectRatio, ";padding-bottom:1rem;.card{width:90%;margin:0 auto;position:absolute;right:5%;bottom:1rem;}"),
        children: /*#__PURE__*/ _jsx(Card, {
            spacing: "sm",
            children: /*#__PURE__*/ _jsx(Typography, {
                type: "h3",
                fontSize: "1rem",
                lineClamp: 3,
                fontWeight: "Bold",
                hoverColor: href && "primary",
                children: title
            })
        })
    });
    if (href) return /*#__PURE__*/ _jsx(Link, {
        href: href,
        children: inner
    });
    return inner;
}
/* harmony default export */ var webpage_ImageCard = ((/* unused pure expression or super */ null && (ImageCard)));

;// CONCATENATED MODULE: ./src/features/webpage/InlineNewsAd.js




function InlineNewsAd(param) {
    var ad = param.ad;
    var ref, ref1, ref2;
    var linkStyle = "display: block; border-radius: 10px; max-width: 25rem; margin: 0 auto; padding: 0.5rem; background: #ffffff; border: 1px dashed #dddddd; a { display: flex; justify-content: center; align-items: center; gap: 0.5rem;}";
    return /*#__PURE__*/ _jsxs(Link, {
        href: generateUrl(ad, "news"),
        style: linkStyle,
        rel: ad.nofollow ? "nofollow" : "",
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    minWidth: "4rem"
                },
                children: /*#__PURE__*/ _jsx(Image, {
                    src: ((ref = ad.thumbnail) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.hash) && "/api/filedb/".concat(ad.thumbnail.file.hash, ".").concat((ref2 = ad.thumbnail.file) === null || ref2 === void 0 ? void 0 : ref2.ext),
                    alt: "picture",
                    width: 200,
                    height: 170,
                    objectFit: "cover",
                    layout: "responsive"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    fontSize: "0.85rem",
                    textAlign: "center",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: "2",
                    WebkitBoxOrient: "vertical"
                },
                children: ad.title
            })
        ]
    });
}
/* harmony default export */ var webpage_InlineNewsAd = ((/* unused pure expression or super */ null && (InlineNewsAd)));

;// CONCATENATED MODULE: ./src/features/webpage/LatestPostsFilter.js







var filterCss = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("border:1px solid #dccdfc;padding:0.125rem 0.5rem;color:#492acd;border-radius:4px;cursor:pointer;text-align:center;white-space:nowrap;& > label{font-size:14px;cursor:pointer;}");
var latestnewsTitleStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("padding:0.5rem;display:inline-flex;gap:0.5rem;margin-bottom:0;flex:1;");
function LatestPostsFilter(param) {
    var _initNews = param.initNews, initNews = _initNews === void 0 ? [] : _initNews, _services = param.services, services = _services === void 0 ? [] : _services, title = param.title;
    var ref, ref1;
    var theme = (0,emotion_element_f0de968e_browser_esm.u)();
    var sortedServices = services === null || services === void 0 ? void 0 : services.sort(function(a, b) {
        return a.position - b.position;
    });
    var ref2 = (0,react.useState)(sortedServices === null || sortedServices === void 0 ? void 0 : (ref = sortedServices[0]) === null || ref === void 0 ? void 0 : ref.id), activeTab = ref2[0], setActiveTab = ref2[1];
    if (!(services === null || services === void 0 ? void 0 : services.length)) return null;
    var ref3;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        style: {
            backgroundColor: "#fff",
            boxShadow: theme.boxShadow.default,
            borderTop: "3px solid ".concat(theme.colors.primary),
            borderRadius: 6
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* SectionTitle */.NZ, {
                color: "primary",
                dividerColor: "lightGray",
                style: {
                    backgroundColor: theme.colors.white
                },
                children: title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                style: {
                    display: "grid",
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    gap: 10,
                    alignItems: "center",
                    borderBottom: "1px dashed #dddddd",
                    fontSize: 16,
                    padding: "0 16px 16px 16px"
                },
                children: services.map(function(service) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        style: {
                            backgroundColor: activeTab === service.id ? "#492acd" : "#f1edfe",
                            color: activeTab === service.id ? "#fff" : "#492acd"
                        },
                        css: filterCss,
                        onClick: function() {
                            setActiveTab(service.id);
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                            htmlFor: "video",
                            children: service.title
                        }, service.id)
                    }, service.id);
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(webpage_WidgetList, {
                widget: initNews === null || initNews === void 0 ? void 0 : (ref1 = initNews[Number(activeTab)]) === null || ref1 === void 0 ? void 0 : ref1.news,
                css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".card-title{margin-bottom:0 !important;}"),
                listStyle: {
                    gap: 0
                },
                divider: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Divider */.iz, {
                    gap: "0"
                }),
                filterItem: false,
                itemRender: function(param) {
                    var post = param.post;
                    var ref;
                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Link */.rU, {
                        href: (0,utils/* generateUrl */.nu)(post, "news"),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                position: "relative",
                                padding: "5px 5px 0"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    style: {
                                        height: 40,
                                        width: 60,
                                        position: "relative"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Image */.Ee, {
                                        width: 60,
                                        height: 40,
                                        objectFit: "cover",
                                        src: post.media ? (0,utils_news/* posterSrc */.ju)(post.media) : (0,utils_news/* thumbnailSrc */.xX)(post.thumbnail),
                                        alt: (ref3 = (ref = post.thumbnail) === null || ref === void 0 ? void 0 : ref.alt) !== null && ref3 !== void 0 ? ref3 : post === null || post === void 0 ? void 0 : post.title
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(base_ui/* Typography */.ZT, {
                                    type: "h4",
                                    fontSize: "0.9rem",
                                    css: latestnewsTitleStyle,
                                    hoverColor: "primary",
                                    children: post.title
                                })
                            ]
                        })
                    });
                }
            })
        ]
    });
}
/* harmony default export */ var webpage_LatestPostsFilter = (LatestPostsFilter);

;// CONCATENATED MODULE: ./src/features/webpage/IconTitle.js





function IconTitle(param) {
    var _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "0.9rem" : _fontSize, _icon = param.icon, icon = _icon === void 0 ? /*#__PURE__*/ _jsx(BsTextRight, {}) : _icon, title = param.title;
    var mainStyle = /*#__PURE__*/ css("padding:0.5rem;display:flex;gap:0.5rem;margin-bottom:0;");
    return /*#__PURE__*/ _jsxs(Typography, {
        type: "h4",
        fontSize: fontSize,
        css: mainStyle,
        hoverColor: "primary",
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: icon
            }),
            title
        ]
    });
}
/* harmony default export */ var webpage_IconTitle = ((/* unused pure expression or super */ null && (IconTitle)));

;// CONCATENATED MODULE: ./src/features/webpage/index.js















/***/ }),

/***/ 46766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x5": function() { return /* reexport */ useDataProvider; }
});

// UNUSED EXPORTS: DataProvider, DataProviderContext

// EXTERNAL MODULE: ./src/hooks/dataProvider/DataProviderContext.js
var DataProviderContext = __webpack_require__(36651);
// EXTERNAL MODULE: ./src/hooks/dataProvider/DataProvider.js
var DataProvider = __webpack_require__(94571);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/dataProvider/useDataProvider.js


function useDataProvider() {
    var data = (0,react.useContext)(DataProviderContext/* DataProviderContext */.C);
    if (data === undefined) {
        throw new Error("useData must be used within a DataProvider");
    }
    return data;
}

;// CONCATENATED MODULE: ./src/hooks/dataProvider/index.js





/***/ }),

/***/ 22807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBreakpoints; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var BREAKPOINTS = {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xl2: false
};
function useBreakpoints(defaultBreakpoints) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, BREAKPOINTS), {
        xs: true
    }), defaultBreakpoints)), breakpoint = ref[0], setBreakpoint = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var updateSize = function updateSize() {
            var w = window.innerWidth;
            if (w <= 640) setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                xs: true
            }));
            else if (w <= 768) setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                sm: true
            }));
            else if (w <= 1024) setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                md: true
            }));
            else if (w <= 1280) setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                lg: true
            }));
            else if (w <= 1536) setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                xl: true
            }));
            else setBreakpoint((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, BREAKPOINTS), {
                xl2: true
            }));
        };
        window.addEventListener("resize", updateSize);
        updateSize();
        return function() {
            return window.removeEventListener("resize", updateSize);
        };
    }, []);
    return breakpoint;
}


/***/ })

}]);